/**
 * พิมพ์สัญญาและหลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว
 * **/

import React, { Component } from "react";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Loading from "../Loading";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { format } from "date-fns";
import { DateUtil } from "../../utils/dateUtil";
import { APIURL } from "../../config/config";
import ThaiBaht from "thai-baht-text";
import NumberFormat from "react-number-format";
import { AlertError, AlertSuccess } from "../Alert/Alert";
import { NumberUtil } from "../../utils/number-util";
import DatePickerIcon from "../DatePickerIcon";
import ThaiDatePicker from "../ThaiDatePicker";
import stringUtil from "../../utils/stringUtil";
import { el } from "date-fns/locale";
import { PDFUtil } from "../../utils/pdfUtil";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();

class CarReceiptOcpd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receipt_ocpd_id: null,
      car_id: "",
      customer_id: "",
      car_sell_id: "",
      car_sell_pay_id: "",
      car_book_id: "",
      isExist: false,
      seller_name: "", // ผู้ขาย
      seller_address: "", // ที่อยู่ผู้ประกอบธุรกิจ
      seller_name2: "", // ผู้มีอำนาจออกหลักฐานการรับเงิน
      seller_address2: "", // ที่อยู่ผู้มีอำนาจออกหลักฐานการรับเงิน
      possessor: "",
      ownership: "",
      car_brand_name: "",
      car_model_name: "",
      car_num_engines: "",
      car_year_name: "", // ปี
      car_color_name: "", // สี
      car_number: "", // เลขตัวรถ
      car_license_plate: "",
      car_miles: "",
      province_name: "",
      obligation: "",
      ocpd_type: "",

      //วันที่ออกหลักฐานรับเงิน สคบ.
      startDateReceiptOcpd: new Date(),
      isOpenDateReceiptOcpd: false,
      receipt_date_ocpd: null,
      receipt_date_ocpd_thai: null,
      //วันที่ส่งมอบสำเนาสมุดคู่มือจดทะเบียนรถยนต์ (ชำระเงินบางส่วน)
      handbook_copy_date: null,
      handbook_copy_date_thai: null,
      startHandbookCopyDate: new Date(),
      isOpenHandbookCopyDate: false,
      //วันที่ส่งมอบรถยนต์ (ชำระเงินครบถ้วน)
      startDateCarDelivery: new Date(),
      isOpenDateCarDelivery: false,
      car_date_delivery: null,
      car_date_delivery_thai: null,
      //วันที่ส่งมอบสมุดคู่มือจดทะเบียนรถยนต์ตัวจริง (ชำระเงินครบถ้วน)
      handbook_date: null,
      handbook_date_thai: null,
      startHandbookDate: new Date(),
      isOpenHandbookDate: false,
      //วันที่จ่ายเงินบางส่วน
      startDatePartPayment: new Date(),
      isOpenDatePartPayment: false,
      part_payment_date: null,
      part_payment_date_thai: null,
      //วันที่จ่ายเงินครบถ้วน
      startDateFullPayment: new Date(),
      isOpenDateFullPayment: false,
      full_payment_date: null,
      full_payment_date_thai: null,
      //ข้อ3 กำหนดส่งมอบรถยนต์
      startSendCarDate: new Date(),
      isOpenSendCarDate: false,
      send_car_date: null,
      send_car_date_thai: null,

      carBase64Img: "",
      sealBase64Img: "",

      //ผู้ซื้อ
      buyer_name: "",
      buyer_address: "",
      some_amount: 0,
      full_amount: 0,
      pay_type: "ชำระบางส่วน",
      receipt_ocpd: null,

      // เพิ่มเติมทำสัญญาเพิ่ม
      sign_seller: "",
      sign_buyer: "",
      sign_evidence: "",
      sign_witness1: "",
      sign_witness2: "",
      location_delivery: "",
      request_loan: "",
      send_doc: "",
      other_note: "",
      pay_method: "",
      pay_method_detail: "",
      car_size_engine: "",
      car_equipment: "",
      car_sufferers: "",
      write_at: "",
      real_sell_price: 0,
      car_name: "",
    };

    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCarSellById = this.loadCarSellById.bind(this);
    this.loadCarReceiptOcpd = this.loadCarReceiptOcpd.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.loadDataCarSellPay = this.loadDataCarSellPay.bind(this);
    this.calOutstanding = this.calOutstanding.bind(this);
    this.saveCarReceiptOcpd = this.saveCarReceiptOcpd.bind(this);
    this.printCarReceiptOcpd = this.printCarReceiptOcpd.bind(this);

    this.handleDateReceiptOcpd = this.handleDateReceiptOcpd.bind(this);
    this.handleHandbookCopyDate = this.handleHandbookCopyDate.bind(this);
    this.handleCarDeliveryDate = this.handleCarDeliveryDate.bind(this);
    this.handleHandbookDate = this.handleHandbookDate.bind(this);
    this.onPayTypeChanged = this.onPayTypeChanged.bind(this);
    this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
    this.loadCompanySealBase64 = this.loadCompanySealBase64.bind(this);

    this.handleDatePartPayment = this.handleDatePartPayment.bind(this);
    this.handleDateFullPayment = this.handleDateFullPayment.bind(this);
    this.handleSendCarDate = this.handleSendCarDate.bind(this);
    this.printContractOcpd = this.printContractOcpd.bind(this);
    this.setCarReceiptOcpd = this.setCarReceiptOcpd.bind(this);
    this.loadCarSellPayAndCarBook = this.loadCarSellPayAndCarBook.bind(this);
  }

  async componentDidMount() {
    this.mounted = true;
    const queryString = require("query-string");
    let car_sell = queryString.parse(this.props.location.search);
    let car_sell_id = car_sell.car_sell_id;
    let car_sell_pay_id = car_sell.car_sell_pay_id;

    if (car_sell_id !== undefined) {
      let ocpd_type = "car_sell";
      this.setState(
        {
          car_sell_id: car_sell_id,
          ocpd_type: ocpd_type,
        },
        async () => {
          await this.loadCompanyLogoBase64();
          await this.loadCompanySetting();
          await this.loadCarReceiptOcpd(car_sell_id, ocpd_type);
          await this.loadCarSellById(car_sell_id);
        }
      );
    } else if (car_sell_pay_id !== undefined) {
      let car_book_id = car_sell.car_book_id;
      let ocpd_type = "car_sell_pay";
      this.setState(
        {
          car_sell_pay_id: car_sell_pay_id,
          car_book_id: car_book_id,
          ocpd_type: ocpd_type,
        },
        async () => {
          await this.loadCompanyLogoBase64();
          await this.loadCompanySetting();
          await this.loadCarReceiptOcpd(car_sell_pay_id, ocpd_type);
          // await this.loadCarSellPayAndCarBook(car_sell_pay_id, car_book_id);
        }
      );
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    // window.removeEventListener('resize', this.updateWindowDimensions);
  }

  async loadCompanySetting() {
    await axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      if (company_setting !== null) {
        this.setState({
          company_setting: company_setting,
          seller_name: company_setting.company_name,
          seller_address: company_setting.company_address,
          seller_name2: company_setting.company_name,
          seller_address2: company_setting.company_address,
          possessor: company_setting.company_name,
        });
      }
    });
  }

  async loadCarReceiptOcpd(id, ocpd_type) {
    // let car_sell_id_or_car_sell_pay_id = id;
    // APIURL + "/receipt_ocpd/car_sell/" + car_sell_id + "/car_sell"
    let url = APIURL + "/receipt_ocpd/car_sell/" + id + "/" + ocpd_type;

    await axios.get(url).then((res) => {
      let data = res.data;
      if (data.length === 1) {
        let ocpd = data[0];

        this.setCarReceiptOcpd(ocpd);
      } else {
        if (ocpd_type === "car_sell_pay") {
          let car_sell_pay_id = this.state.car_sell_pay_id;
          let car_book_id = this.state.car_book_id;
          this.loadCarSellPayAndCarBook(car_sell_pay_id, car_book_id);
        }
        console.log("ไม่พบข้อมูลหลักฐานการรับเงิน");
      }
    });
  }

  setCarReceiptOcpd(ocpd) {
    let receipt_date_ocpd = moment(ocpd.receipt_date_ocpd).format("YYYY-MM-DD");
    let receipt_date_ocpd_thai =
      DateUtil.convertLongDateThai(receipt_date_ocpd);

    let handbook_copy_date = "";
    let handbook_copy_date_thai = "";
    let startHandbookCopyDate = null;
    if (
      ocpd.handbook_copy_date !== null &&
      ocpd.handbook_copy_date !== "0000-00-00"
    ) {
      handbook_copy_date = format(
        new Date(ocpd.handbook_copy_date),
        "yyyy-MM-dd"
      );
      handbook_copy_date_thai =
        DateUtil.convertLongDateThai(handbook_copy_date);
      startHandbookCopyDate = new Date(handbook_copy_date);
    }

    let car_date_delivery = "";
    let car_date_delivery_thai = "";
    let startDateCarDelivery = null;
    if (
      ocpd.car_date_delivery !== null &&
      ocpd.car_date_delivery !== "0000-00-00"
    ) {
      car_date_delivery = format(
        new Date(ocpd.car_date_delivery),
        "yyyy-MM-dd"
      );
      car_date_delivery_thai = DateUtil.convertLongDateThai(car_date_delivery);
      startDateCarDelivery = new Date(car_date_delivery);
    }

    let handbook_date = "";
    let handbook_date_thai = "";
    let startHandbookDate = null;
    if (ocpd.handbook_date !== null && ocpd.handbook_date !== "0000-00-00") {
      // handbook_date =  moment(ocpd.handbook_date).format('YYYY-MM-DD')
      handbook_date = format(new Date(ocpd.handbook_date), "yyyy-MM-dd");
      handbook_date_thai = DateUtil.convertLongDateThai(handbook_date);
      startHandbookDate = new Date(handbook_date);
    }

    let part_payment_date = "";
    let part_payment_date_thai = "";
    let startDatePartPayment = null;
    if (
      ocpd.part_payment_date !== null &&
      ocpd.part_payment_date !== "0000-00-00"
    ) {
      part_payment_date = format(
        new Date(ocpd.part_payment_date),
        "yyyy-MM-dd"
      );
      part_payment_date_thai = DateUtil.convertLongDateThai(part_payment_date);
      startDatePartPayment = new Date(part_payment_date);
    }

    let full_payment_date = "";
    let full_payment_date_thai = "";
    let startDateFullPayment = null;
    if (
      ocpd.full_payment_date !== null &&
      ocpd.full_payment_date !== "0000-00-00"
    ) {
      full_payment_date = format(
        new Date(ocpd.full_payment_date),
        "yyyy-MM-dd"
      );
      full_payment_date_thai = DateUtil.convertLongDateThai(full_payment_date);
      startDateFullPayment = new Date(full_payment_date);
    }

    let send_car_date = "";
    let send_car_date_thai = "";
    let startSendCarDate = null;
    if (ocpd.send_car_date !== null && ocpd.send_car_date !== "0000-00-00") {
      send_car_date = format(new Date(ocpd.send_car_date), "yyyy-MM-dd");
      send_car_date_thai = DateUtil.convertLongDateThai(send_car_date);
      startSendCarDate = new Date(send_car_date);
    }

    //console.log(ocpd.pay_type)

    this.setState({
      receipt_ocpd: ocpd,
      receipt_ocpd_id: ocpd.receipt_ocpd_id,
      pay_type: ocpd.pay_type,
      buyer_name: ocpd.buyer_name,
      buyer_address: ocpd.buyer_address,
      car_id: ocpd.car_id,
      car_sell_id: ocpd.car_sell_id,
      customer_id: ocpd.customer_id,

      car_date_delivery: car_date_delivery,
      car_date_delivery_thai: car_date_delivery_thai,
      startDateCarDelivery: startDateCarDelivery,

      receipt_date_ocpd: ocpd.receipt_date_ocpd,
      receipt_date_ocpd_thai: receipt_date_ocpd_thai,

      handbook_copy_date: handbook_copy_date,
      handbook_copy_date_thai: handbook_copy_date_thai,
      startHandbookCopyDate: startHandbookCopyDate,

      handbook_date: handbook_date,
      handbook_date_thai: handbook_date_thai,
      startHandbookDate: startHandbookDate,

      part_payment_date: part_payment_date,
      part_payment_date_thai: part_payment_date_thai,
      startDatePartPayment: startDatePartPayment,

      full_payment_date: full_payment_date,
      full_payment_date_thai: full_payment_date_thai,
      startDateFullPayment: startDateFullPayment,

      send_car_date: send_car_date,
      send_car_date_thai: send_car_date_thai,
      startSendCarDate: startSendCarDate,

      seller_name: ocpd.seller_name,
      seller_address: ocpd.seller_address,
      seller_name2: ocpd.seller_name2,
      seller_address2: ocpd.seller_address2,
      car_num_engines: ocpd.car_num_engines,
      car_year_name: ocpd.car_year_name,
      car_color_name: ocpd.car_color_name,
      car_license_plate: ocpd.car_license_plate,
      car_number: ocpd.car_number,
      car_miles: ocpd.car_miles,
      car_brand_name: ocpd.car_brand_name,
      car_model_name: ocpd.car_model_name,
      province_name: ocpd.province_name,
      possessor: ocpd.possessor,
      ownership: ocpd.ownership,
      obligation: ocpd.obligation,
      some_amount: ocpd.some_amount,
      full_amount: ocpd.full_amount,

      sign_seller: ocpd.sign_seller,
      sign_buyer: ocpd.sign_buyer,
      sign_evidence: ocpd.sign_evidence,
      sign_witness1: ocpd.sign_witness1,
      sign_witness2: ocpd.sign_witness2,
      location_delivery: ocpd.location_delivery,
      request_loan: ocpd.request_loan,
      send_doc: ocpd.send_doc,
      other_note: ocpd.other_note,
      pay_method: ocpd.pay_method,
      pay_method_detail: ocpd.pay_method_detail,
      car_size_engine: ocpd.car_size_engine,
      car_equipment: ocpd.car_equipment,
      car_sufferers: ocpd.car_sufferers,
      write_at: ocpd.write_at,
      real_sell_price: ocpd.real_sell_price,
      car_name: ocpd.car_name,
    });
  }

  async loadCarSellById(car_sell_id) {
    if (this.state.receipt_ocpd_id !== null) {
      // มีรายการหลักฐานการรับเงินแล้ว
      return;
    }

    await axios
      .get(APIURL + "/car_sell/" + car_sell_id)
      .then((res) => {
        if (this.mounted) {
          let car_sell = res.data[0];
          let car_sell_date = car_sell.car_sell_date;
          let date = new Date(car_sell_date);
          let customer_lastname = car_sell.customer_lastname;
          let buyer_name = car_sell.customer_name + " " + customer_lastname; // ผู้ซื้อ
          let buyer_address = car_sell.customer_address; // ผู้ซื้อ
          let car_id = car_sell.car_id;
          let customer_id = car_sell.customer_id;
          let car_num_engines = car_sell.car_num_engines; // เลขเครื่องยนต์
          let car_year_name = car_sell.car_year_name; // ปี
          let car_color_name = car_sell.car_color_name; // สี
          let car_license_plate =
            car_sell.car_license_plate_new !== "" &&
            car_sell.car_license_plate_new !== car_sell.car_license_plate_old
              ? car_sell.car_license_plate_new
              : car_sell.car_license_plate_old;
          let province_name =
            car_sell.car_license_plate_new !== "" &&
            car_sell.car_license_plate_new !== car_sell.car_license_plate_old
              ? car_sell.province_name_new
              : car_sell.province_name_old;
          let car_number = car_sell.car_number; // เลขตัวรถ
          let car_miles = car_sell.car_miles; // ระยะทาง

          let car_brand_name = car_sell.car_brand_name; // ยี่ห้อ
          let car_model_name = car_sell.car_model_name; // รุ่น
          let car_lastname_owner_old = car_sell.car_lastname_owner_old;
          let car_name_owner_old = car_sell.car_name_owner_old;
          let ownership = car_name_owner_old + " " + car_lastname_owner_old; // ผู้ถือกรรมสิทธิ์
          let real_sell_price = car_sell.real_sell_price; // ราคาซื้อขาย
          let car_size_engine = car_sell.car_size_engine; // ขนาดกำลังเครื่องยนต์
          let car_name = car_sell.car_name; // ชื่อรถ

          this.setState(
            {
              buyer_name,
              buyer_address,
              car_id,
              customer_id,

              car_num_engines,
              car_year_name,
              car_color_name,
              car_license_plate,
              car_number,
              car_miles,

              car_brand_name,
              car_model_name,
              province_name,
              ownership,
              real_sell_price,
              car_size_engine,
              car_name,
              car_sell_id,
            },
            () => {
              this.loadDataCarSellPay(car_sell, car_id, customer_id);
            }
          );
        }
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCarSellPayAndCarBook(car_sell_pay_id, car_book_id) {
    // console.log("loadCarSellPayAndCarBook car_sell_pay_id=", car_sell_pay_id);
    let url =
      APIURL + "/car_sell_pay/ocpd/" + car_sell_pay_id + "/" + car_book_id;
    axios
      .get(url)
      .then((res) => {
        if (res.status === 200) {
          // console.log("res.data=", res.data);
          if (res.data.car_sell_pay.length === 1) {
            let car_sell = res.data.car_sell_pay[0];
            let car_book = res.data.car_book;
            // console.log("carSellPay=", car_sell);
            // console.log("car_book=", car_book);

            let customer_lastname = car_sell.customer_lastname;
            let buyer_name = car_sell.customer_name + " " + customer_lastname; // ผู้ซื้อ
            let buyer_address = car_sell.customer_address; // ผู้ซื้อ
            let car_id = car_sell.car_id;
            let customer_id = car_sell.customer_id;
            let car_num_engines = car_sell.car_num_engines; // เลขเครื่องยนต์
            let car_year_name = car_sell.car_year_name; // ปี
            let car_color_name = car_sell.car_color_name; // สี
            let car_license_plate =
              car_sell.car_license_plate_new !== "" &&
              car_sell.car_license_plate_new !== car_sell.car_license_plate_old
                ? car_sell.car_license_plate_new
                : car_sell.car_license_plate_old;
            let province_name =
              car_sell.car_license_plate_new !== "" &&
              car_sell.car_license_plate_new !== car_sell.car_license_plate_old
                ? car_sell.province_name_new
                : car_sell.province_name_old;

            let car_number = car_sell.car_number; // เลขตัวรถ
            let car_miles = car_sell.car_miles; // ระยะทาง

            let car_brand_name = car_sell.car_brand_name; // ยี่ห้อ
            let car_model_name = car_sell.car_model_name; // รุ่น
            let car_lastname_owner_old = car_sell.car_lastname_owner_old;
            let car_name_owner_old = car_sell.car_name_owner_old;
            let ownership = car_name_owner_old + " " + car_lastname_owner_old; // ผู้ถือกรรมสิทธิ์

            let car_size_engine = car_sell.car_size_engine; // ขนาดกำลังเครื่องยนต์
            let car_name = car_sell.car_name; // ชื่อรถ
            let car_sell_id = "";

            let real_sell_price = car_sell.car_sale_price; // ราคาตั้งขาย
            if (car_book !== null) {
              real_sell_price = car_book.cost_car_book; // ราคาจอง
            }

            let pay_type = "";
            let some_amount = 0;
            let full_amount = 0;
            let car_sell_pay_count = car_sell.car_sell_pay_count; // จำนวนเงินที่จ่ายไปแล้ว
            if (car_sell_pay_count < real_sell_price) {
              // จำนวนเงินที่จ่ายไปแล้ว
              some_amount = car_sell.car_sell_pay_count;
              full_amount = 0;
              pay_type = "ชำระบางส่วน";
            } else {
              pay_type = "ชำระครบถ้วน";
              some_amount = 0;
              full_amount = real_sell_price;
            }
            // some_amount

            this.setState({
              buyer_name,
              buyer_address,
              car_id,
              customer_id,

              car_num_engines,
              car_year_name,
              car_color_name,
              car_license_plate,
              car_number,
              car_miles,

              car_brand_name,
              car_model_name,
              province_name,
              ownership,
              real_sell_price,
              car_size_engine,
              car_name,
              car_sell_id,
              some_amount,
              pay_type,
            });
          }
        }
      })
      .catch((error) => {
        // alert("error"+error.message);
        // this.setState({carBookEdit: {}})
      });
  }

  handleDateReceiptOcpd(date) {
    let receipt_date_ocpd = moment(date).format("YYYY-MM-DD");
    let receipt_date_ocpd_thai =
      DateUtil.convertLongDateThai(receipt_date_ocpd);

    this.setState({
      startDateReceiptOcpd: date,
      isOpenDateReceiptOcpd: false,
      receipt_date_ocpd: receipt_date_ocpd,
      receipt_date_ocpd_thai: receipt_date_ocpd_thai,
    });
  }

  handleDatePartPayment(date) {
    let part_payment_date = moment(date).format("YYYY-MM-DD");
    let part_payment_date_thai =
      DateUtil.convertLongDateThai(part_payment_date);

    this.setState({
      startDatePartPayment: date,
      isOpenDatePartPayment: false,
      part_payment_date: part_payment_date,
      part_payment_date_thai: part_payment_date_thai,
    });
  }

  handleDateFullPayment(date) {
    let full_payment_date = moment(date).format("YYYY-MM-DD");
    let full_payment_date_thai =
      DateUtil.convertLongDateThai(full_payment_date);

    this.setState({
      startDateFullPayment: date,
      isOpenDateFullPayment: false,
      full_payment_date: full_payment_date,
      full_payment_date_thai: full_payment_date_thai,
    });
  }

  handleHandbookCopyDate(date) {
    let handbook_copy_date = moment(date).format("YYYY-MM-DD");
    let handbook_copy_date_thai =
      DateUtil.convertLongDateThai(handbook_copy_date);

    this.setState({
      startHandbookCopyDate: date,
      isOpenHandbookCopyDate: false,
      handbook_copy_date: handbook_copy_date,
      handbook_copy_date_thai: handbook_copy_date_thai,
    });
  }

  handleCarDeliveryDate(date) {
    let car_date_delivery = moment(date).format("YYYY-MM-DD");
    let car_date_delivery_thai =
      DateUtil.convertLongDateThai(car_date_delivery);

    this.setState({
      startDateCarDelivery: date,
      isOpenDateCarDelivery: false,
      car_date_delivery: car_date_delivery,
      car_date_delivery_thai: car_date_delivery_thai,
    });
  }

  handleHandbookDate(date) {
    let handbook_date = moment(date).format("YYYY-MM-DD");
    let handbook_date_thai = DateUtil.convertLongDateThai(handbook_date);

    let send_car_date = moment(date).format("YYYY-MM-DD");
    let send_car_date_thai = DateUtil.convertLongDateThai(send_car_date);

    this.setState({
      send_car_date: send_car_date,
      send_car_date_thai: send_car_date_thai,
      startSendCarDate: date,
      //
      startHandbookDate: date,
      isOpenHandbookDate: false,
      handbook_date: handbook_date,
      handbook_date_thai: handbook_date_thai,
    });
  }

  //ข้อ 3. กำหนดส่งมอบรถยนต์ ส่งมอบสมุดคู่มือตามกรมขนส่ง
  handleSendCarDate(date) {
    let send_car_date = moment(date).format("YYYY-MM-DD");
    let send_car_date_thai = DateUtil.convertLongDateThai(send_car_date);

    this.setState({
      startSendCarDate: date,
      isOpenSendCarDate: false,
      send_car_date: send_car_date,
      send_car_date_thai: send_car_date_thai,
    });
  }

  handleOnChange(e) {
    let name = e.target.name;
    let val = e.target.value;

    this.setState({
      [name]: val,
    });
  }

  calOutstanding() {
    let some_amount = this.state.some_amount;
    let full_amount = this.state.full_amount;
    this.setState({
      //outstanding: outstanding
    });
  }

  onPayTypeChanged(e) {
    //console.log(e.currentTarget.value)
    let pay_type = e.currentTarget.value;

    if (pay_type === "ชำระครบถ้วน" && this.state.receipt_ocpd_id === null) {
      let startDateCarDelivery = new Date();
      let car_date_delivery = moment().format("YYYY-MM-DD");
      let car_date_delivery_thai =
        DateUtil.convertLongDateThai(car_date_delivery);

      let startHandbookDate = new Date();
      let handbook_date = moment().format("YYYY-MM-DD");
      let handbook_date_thai = DateUtil.convertLongDateThai(handbook_date);

      let startHandbookCopyDate = new Date();
      let handbook_copy_date = moment().format("YYYY-MM-DD");
      let handbook_copy_date_thai =
        DateUtil.convertLongDateThai(handbook_copy_date);

      let startDateFullPayment = new Date();
      let full_payment_date = moment().format("YYYY-MM-DD");
      let full_payment_date_thai =
        DateUtil.convertLongDateThai(full_payment_date);

      this.setState({
        pay_type: pay_type,
        //startDateCarDelivery : startDateCarDelivery,
        //car_date_delivery : car_date_delivery,
        //car_date_delivery_thai : car_date_delivery_thai,
        startHandbookDate: startHandbookDate,
        handbook_date: handbook_date,
        handbook_date_thai: handbook_date_thai,

        startDateFullPayment: startDateFullPayment,
        full_payment_date: full_payment_date,
        full_payment_date_thai: full_payment_date_thai,

        some_amount: 0,
        pay_method: "cash",
        handbook_copy_date: "",
        handbook_copy_date_thai: "",
        part_payment_date: "",
        part_payment_date_thai: "",
      });
    } else if (
      pay_type === "ชำระบางส่วน" &&
      this.state.receipt_ocpd_id === null
    ) {
      this.setState({
        pay_type: pay_type,
        handbook_date: "",
        handbook_date_thai: "",
        full_payment_date: "",
        full_payment_date_thai: "",
        full_amount: 0,
        pay_method: "",
        pay_method_detail: "",
      });
    } else if (
      pay_type === "ชำระครบถ้วน" &&
      this.state.receipt_ocpd_id !== null
    ) {
      let receipt_ocpd = this.state.receipt_ocpd;

      let handbook_date = "";
      let handbook_date_thai = "";
      let startHandbookDate = null;
      if (
        receipt_ocpd.handbook_date !== null &&
        receipt_ocpd.handbook_date !== "0000-00-00"
      ) {
        handbook_date = moment(receipt_ocpd.handbook_date).format("YYYY-MM-DD");
        handbook_date_thai = DateUtil.convertLongDateThai(handbook_date);
        startHandbookDate = new Date(handbook_date);
      }

      let car_date_delivery = "";
      let car_date_delivery_thai = "";
      let startDateCarDelivery = null;
      if (
        receipt_ocpd.car_date_delivery !== null &&
        receipt_ocpd.car_date_delivery !== "0000-00-00"
      ) {
        car_date_delivery = moment(receipt_ocpd.car_date_delivery).format(
          "YYYY-MM-DD"
        );
        car_date_delivery_thai =
          DateUtil.convertLongDateThai(car_date_delivery);
        startDateCarDelivery = new Date(car_date_delivery);
      }

      let full_amount = "";
      let some_amount = "";

      //let receipt_ocpd = this.state.receipt_ocpd

      let handbook_copy_date = "";
      let handbook_copy_date_thai = "";
      let startHandbookCopyDate = null;
      if (
        receipt_ocpd.handbook_copy_date !== null &&
        receipt_ocpd.handbook_copy_date !== "0000-00-00"
      ) {
        handbook_copy_date = moment(receipt_ocpd.handbook_copy_date).format(
          "YYYY-MM-DD"
        );
        handbook_copy_date_thai =
          DateUtil.convertLongDateThai(handbook_copy_date);
        startHandbookCopyDate = new Date(handbook_copy_date);
      }

      this.setState({
        pay_type: pay_type,
        //car_date_delivery: receipt_ocpd.car_date_delivery,
        //car_date_delivery_thai: car_date_delivery_thai,
        handbook_date: handbook_date,
        handbook_date_thai: handbook_date_thai,
        startHandbookDate: startHandbookDate,
        full_amount: receipt_ocpd.full_amount,

        some_amount: 0,
        pay_method: "cash",
        handbook_copy_date: "",
        handbook_copy_date_thai: "",
        startHandbookCopyDate: "",
        part_payment_date: "",
        part_payment_date_thai: "",
      });
    } else if (
      pay_type === "ชำระบางส่วน" &&
      this.state.receipt_ocpd_id !== null
    ) {
      let receipt_ocpd = this.state.receipt_ocpd;

      let handbook_copy_date = "";
      let handbook_copy_date_thai = "";
      let startHandbookCopyDate = null;
      if (
        receipt_ocpd.handbook_copy_date !== null &&
        receipt_ocpd.handbook_copy_date !== "0000-00-00"
      ) {
        handbook_copy_date = moment(receipt_ocpd.handbook_copy_date).format(
          "YYYY-MM-DD"
        );
        handbook_copy_date_thai =
          DateUtil.convertLongDateThai(handbook_copy_date);
        startHandbookCopyDate = new Date(handbook_copy_date);
      }

      this.setState({
        pay_type: pay_type,
        handbook_copy_date: handbook_copy_date,
        handbook_copy_date_thai: handbook_copy_date_thai,
        startHandbookCopyDate: startHandbookCopyDate,
        some_amount: receipt_ocpd.some_amount,

        //car_date_delivery: '',
        //car_date_delivery_thai: '',
        handbook_date: "",
        handbook_date_thai: "",
        startHandbookDate: "",

        full_amount: 0,
        pay_method: "",
        pay_method_detail: "",
        full_payment_date: "",
        full_payment_date_thai: "",
      });
    } else {
      this.setState({
        pay_type: pay_type,
      });
    }
  }

  loadDataCarSellPay(car_sell, car_id, customer_id) {
    if (car_id === "" || customer_id === "") {
      return;
    }

    axios
      .get(APIURL + "/car_sell_pay/buy/" + car_id + "/" + customer_id)
      .then((res) => {
        let car_sell_pay_list = res.data;
        let sum_pay = car_sell_pay_list.reduce(
          (acc, pay) => acc + pay.car_sell_pay_count,
          0
        );

        let real_sell_price = this.state.real_sell_price;
        let outstanding = Number(real_sell_price) - sum_pay;

        this.setState({
          cash_pledge: sum_pay,
          outstanding: outstanding,
        });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCompanyLogoBase64() {
    let uri = APIURL + "/company_setting/logoimage/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ carBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCompanySealBase64() {
    let uri = APIURL + "/company_setting/companyseal/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ sealBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  saveCarReceiptOcpd(action) {
    let buyer_name = this.state.buyer_name;
    let buyer_address = this.state.buyer_address;
    let car_id = this.state.car_id;
    let customer_id = this.state.customer_id;
    let car_sell_id = this.state.car_sell_id;
    let obligation = this.state.obligation;
    let possessor = this.state.possessor;
    let ownership = this.state.ownership;
    let some_amount = this.state.some_amount;
    let full_amount = this.state.full_amount;
    let pay_type = this.state.pay_type;
    //let contract_type = 'sell' // sell, buy
    let seller_name = this.state.seller_name;
    let seller_address = this.state.seller_address;
    let seller_name2 = this.state.seller_name2;
    let seller_address2 = this.state.seller_address2;
    let car_brand_name = this.state.car_brand_name;
    let car_model_name = this.state.car_model_name;
    let car_num_engines = this.state.car_num_engines;
    let car_year_name = this.state.car_year_name;
    let car_color_name = this.state.car_color_name;
    let car_license_plate = this.state.car_license_plate;
    let car_number = this.state.car_number;
    let car_miles = this.state.car_miles;
    let province_name = this.state.province_name;

    let receipt_date_ocpd = this.state.receipt_date_ocpd;
    let handbook_copy_date = this.state.handbook_copy_date;
    let car_date_delivery = this.state.car_date_delivery;
    let handbook_date = this.state.handbook_date;
    let receipt_date_ocpd_thai = this.state.receipt_date_ocpd_thai;

    let sign_seller = this.state.sign_seller;
    let sign_buyer = this.state.sign_buyer;
    let sign_evidence = this.state.sign_evidence;
    let sign_witness1 = this.state.sign_witness1;
    let sign_witness2 = this.state.sign_witness2;
    let location_delivery = this.state.location_delivery;
    let request_loan = this.state.request_loan;
    let send_doc = this.state.send_doc;
    let other_note = this.state.other_note;
    let pay_method = this.state.pay_method;
    let pay_method_detail = this.state.pay_method_detail;
    let car_size_engine = this.state.car_size_engine;
    let car_equipment = this.state.car_equipment;
    let car_sufferers = this.state.car_sufferers;
    let write_at = this.state.write_at;
    let real_sell_price = this.state.real_sell_price;
    let car_name = this.state.car_name;
    let part_payment_date = this.state.part_payment_date;
    let full_payment_date = this.state.full_payment_date;
    let send_car_date = this.state.send_car_date;

    let ocpd_type = this.state.ocpd_type;
    let car_sell_pay_id = this.state.car_sell_pay_id;

    if (receipt_date_ocpd_thai === null) {
      AlertError("กรุณาเลือกวันที่ทำสัญญา/วันที่ออกหลักฐานการรับเงิน");
      return;
    }
    receipt_date_ocpd = format(new Date(receipt_date_ocpd), "yyyy-MM-dd");

    let data = {
      buyer_name: buyer_name,
      buyer_address: buyer_address,
      car_id: car_id,
      customer_id: customer_id,
      car_sell_id: car_sell_id,
      pay_type: pay_type,
      obligation: obligation,
      possessor: possessor,
      ownership: ownership,
      some_amount: some_amount,
      full_amount: full_amount,
      receipt_date_ocpd: receipt_date_ocpd,
      handbook_copy_date: handbook_copy_date,
      car_date_delivery: car_date_delivery,
      handbook_date: handbook_date,
      seller_name: seller_name,
      seller_address: seller_address,
      seller_name2: seller_name2,
      seller_address2: seller_address2,
      car_num_engines: car_num_engines,
      car_year_name: car_year_name,
      car_color_name: car_color_name,
      car_license_plate: car_license_plate,
      car_number: car_number,
      car_brand_name: car_brand_name,
      car_model_name: car_model_name,
      car_miles: car_miles,
      province_name: province_name,

      sign_seller: sign_seller,
      sign_buyer: sign_buyer,
      sign_evidence: sign_evidence,
      sign_witness1: sign_witness1,
      sign_witness2: sign_witness2,
      location_delivery: location_delivery,
      request_loan: request_loan,
      send_doc: send_doc,
      other_note: other_note,
      pay_method: pay_method,
      pay_method_detail: pay_method_detail,
      car_size_engine: car_size_engine,
      car_equipment: car_equipment,
      car_sufferers: car_sufferers,
      write_at: write_at,
      real_sell_price: real_sell_price,
      car_name: car_name,
      part_payment_date: part_payment_date,
      full_payment_date: full_payment_date,
      send_car_date: send_car_date,
      ocpd_type: ocpd_type,
      car_sell_pay_id: car_sell_pay_id,
    };

    this.setState(
      {
        isLoading: true,
      },
      () => {
        if (action === "add") {
          let url = APIURL + "/receipt_ocpd";
          axios
            .post(url, data)
            .then((res) => {
              if (res.status === 200) {
                let resData = res.data;
                let receipt_ocpd_id = resData.receipt_ocpd_id;

                AlertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว");
                this.setState(
                  {
                    isLoading: false,
                    receipt_ocpd_id: receipt_ocpd_id,
                    // isExist: true,
                  },
                  () => {
                    let id =
                      ocpd_type === "car_sell" ? car_sell_id : car_sell_pay_id;
                    this.loadCarReceiptOcpd(id, ocpd_type);
                  }
                );
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        } else if (action === "edit") {
          let receipt_ocpd_id = this.state.receipt_ocpd_id;
          let editData = { ...data, receipt_ocpd_id: receipt_ocpd_id };
          let url = APIURL + "/receipt_ocpd";
          axios
            .put(url, editData)
            .then((res) => {
              if (res.data === "success") {
                AlertSuccess("แก้ไขข้อมูลเรียบร้อยแล้ว");
                this.setState(
                  {
                    isLoading: false,
                  },
                  () => {
                    // this.loadCarReceiptOcpd(car_sell_id)
                    let id =
                      ocpd_type === "car_sell" ? car_sell_id : car_sell_pay_id;
                    this.loadCarReceiptOcpd(id, ocpd_type);
                  }
                );
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        }
      }
    );
  }

  printCarReceiptOcpd() {
    const { carBase64Img } = this.state;

    let buyer_name = this.state.buyer_name;
    let buyer_address = this.state.buyer_address;
    let car_id = this.state.car_id;
    let customer_id = this.state.customer_id;
    let car_sell_id = this.state.car_sell_id;
    let obligation = this.state.obligation;
    let possessor = this.state.possessor;
    let ownership = this.state.ownership;
    let some_amount = this.state.some_amount;
    let full_amount = this.state.full_amount;
    let pay_type = this.state.pay_type;

    let seller_name = this.state.seller_name;
    let seller_address = this.state.seller_address;
    let seller_name2 = this.state.seller_name2;
    let seller_address2 = this.state.seller_address2;

    let car_brand_name = this.state.car_brand_name;
    let car_model_name = this.state.car_model_name;
    let car_num_engines = this.state.car_num_engines;
    let car_year_name = this.state.car_year_name;
    let car_color_name = this.state.car_color_name;
    let car_license_plate = this.state.car_license_plate;
    let car_number = this.state.car_number;
    let car_miles = this.state.car_miles;
    let province_name = this.state.province_name;

    let receipt_date_ocpd = this.state.receipt_date_ocpd;
    let handbook_copy_date = this.state.handbook_copy_date;
    let handbook_date = this.state.handbook_date;
    let car_date_delivery = this.state.car_date_delivery;

    let receipt_date_ocpd_thai = this.state.receipt_date_ocpd_thai;
    let handbook_copy_date_thai = this.state.handbook_copy_date_thai;

    let handbook_date_thai = this.state.handbook_date_thai;

    let car_date_delivery_thai = this.state.car_date_delivery_thai;
    if (pay_type === "ชำระบางส่วน") {
      car_date_delivery_thai = "";
    }

    let headerLeft;
    let headerCenter;

    let some_text =
      "..................................................................................";

    if (some_amount > 0) {
      some_text =
        NumberUtil.addCommas(parseInt(some_amount, 10)) +
        " " +
        " บาท " +
        " " +
        "(..." +
        ThaiBaht(some_amount) +
        "...)";
    }

    let full_text =
      "..................................................................................";

    if (full_amount > 0) {
      full_text =
        NumberUtil.addCommas(parseInt(full_amount, 10)) +
        " " +
        " บาท " +
        " " +
        "(..." +
        ThaiBaht(full_amount) +
        "...)";
    }

    headerLeft = {
      image: carBase64Img,
      width: 80,
    };
    //headerCenter = ' หลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว'

    let tableHeader = {
      table: {
        widths: ["20%", "60%", "20%"],
        body: [
          [
            { image: carBase64Img, width: 80, rowSpan: 3, layout: "border" },
            {
              text: " หลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว ",
              style: "head",
            },
            "",
          ],
          [
            "",
            {
              text: " ตามประกาศคณะกรรมการว่าด้วยสัญญา เรื่องให้ธุรกิจขายรถยนต์ใช้แล้ว ",
              style: "head2",
            },
            "",
          ],
          [
            "",
            {
              text: " เป็นธุรกิจที่ควบคุมรายการในหลักฐานการรับเงิน พ.ศ. ๒๕๕๐ ",
              style: "head2",
            },
            "",
          ],
          [
            {
              text: "วันที่ " + receipt_date_ocpd_thai,
              style: "normalRight",
              colSpan: 3,
            },
            "",
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.9,
    };

    let tableSeller = {
      table: {
        widths: ["48%", "52%"],
        body: [
          [
            {
              text: "ชื่อ/ที่อยู่ของผู้ประกอบธุรกิจ (ผู้ขาย)",
              style: "sellerHead",
              border: [false, false, true, false],
            },
            {
              text: "ชื่อ/ที่อยู่ของผู้มีอำนาจออกหลักฐานการรับเงิน",
              style: "sellerHead",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "บริษัท...." + seller_name,
              style: "normalMini",
              width: "48%",
              border: [false, false, true, false],
            },
            {
              text: "ชื่อ...." + seller_name2,
              style: "normalMini",
              width: "52%",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "ที่อยู่...." + seller_address,
              style: "normalMini",
              width: "48%",
              border: [false, false, true, false],
            },
            {
              text: "ที่อยู่...." + seller_address2,
              style: "normalMini",
              width: "52%",
              border: [false, false, false, false],
            },
          ],
        ],
      },
      lineHeight: 0.75,
      //layout: 'noBorders',
      border: [false, true, true, false],
    };

    let tableBuyer = {
      table: {
        widths: ["100%"],
        body: [
          [{ text: "ชื่อ/ที่อยู่ของลูกค้า (ผู้ซื้อ)", style: "normalBigBold" }],
          [{ text: "ชื่อ...." + buyer_name + "......", style: "normalBig" }],
          [
            {
              text: "ที่อยู่...." + buyer_address + "......",
              style: "normalBig",
            },
          ],
        ],
      },
      layout: "noBorders",
      border: [false, true, false, false],
      margin: [8, 0, 0, 0],
    };

    let tableCarDetail = {
      table: {
        widths: ["30%", "70%"],
        body: [
          [{ text: "รายละเอียดรถยนต์", style: "normalBold" }, ""],
          [
            {
              text: "ยี่ห้อ........" + car_brand_name + "........",
              style: "normal",
              width: "30%",
            },
            {
              text: "หมายเลขเครื่องยนต์........" + car_num_engines + "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "รุ่น..........." + car_model_name + "........",
              style: "normal",
              width: "30%",
            },
            {
              text: "หมายเลขตัวถัง..............." + car_number + "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "ปี............." + car_year_name + "..................",
              style: "normal",
              width: "30%",
            },
            {
              text:
                "หมายเลขทะเบียน.........." +
                car_license_plate +
                "  " +
                province_name +
                "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "สี............." + car_color_name + "..................",
              style: "normal",
              width: "32%",
            },
            {
              text:
                "ระยะทางการใช้รถยนต์.........." +
                car_miles +
                "..." +
                "กิโลเมตร" +
                "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text:
                "ภาระผูกพัน (ถ้ามี)......................................." +
                obligation +
                "............................................",
              style: "normal",
              colSpan: 2,
            },
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.75,
      border: [false, true, true, false],
    };

    let tablePossessor = {
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text: "ผู้ถือกรรมสิทธิ์......" + ownership + "......",
              style: "normalBig",
              colspan: 3,
            },
          ],
          [
            {
              text: "ผู้ครอบครอง........." + possessor + "......",
              style: "normalBig",
              colspan: 3,
            },
          ],
        ],
      },
      layout: "noBorders",
      border: [false, true, false, false],
      margin: [8, 32, 0, 0],
    };

    let tableSomeAmount = {
      table: {
        widths: ["90%", "10%"],
        body: [
          [{ text: "กรณีชำระเงินค่ารถยนต์บางส่วน", style: "normalBold" }, ""],
          [
            {
              text: "๑. จำนวนเงิน..." + some_text,
              style: "normal",
              colspan: 2,
            },
            "",
          ],
          [
            {
              text:
                "๒. ผู้ขายตกลงส่งมอบสำเนาสมุดคู่มือจดทะเบียนรถยนต์ ในวันที่..." +
                handbook_copy_date_thai +
                "...",
              style: "normal",
              colspan: 2,
            },
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.8,
      border: [false, true, true, true],
    };

    let tableFullAmount = {
      table: {
        widths: ["100%"],
        body: [
          [{ text: "กรณีชำระเงินค่ารถยนต์ครบถ้วน", style: "normalBold" }],
          [{ text: "๑. จำนวนเงิน..." + full_text, style: "normal" }],
          [
            {
              text:
                "๒. ผู้ขายตกลงส่งมอบรถยนต์ ในวันที่..." +
                car_date_delivery_thai +
                "...",
              style: "normal",
            },
          ],
          [
            {
              text:
                "๓. ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถยนต์พร้อมเอกสารที่จำเป็นสำหรับ การจดทะเบียนรถยนต์ ตามที่กรมการขนส่งทางบกกำหนดให้กับผู้ซื้อ ในวันที่..." +
                handbook_date_thai +
                "...",
              style: "normal",
            },
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.8,
      border: [false, true, false, true],
    };

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "landscape",
      pageSize: "A4",
      pageMargins: [45, 25, 45, 0],
      content: [
        tableHeader,
        {
          table: {
            widths: ["55%", "45%"],
            body: [
              [tableSeller, tableBuyer],
              [tableCarDetail, tablePossessor],
              [tableSomeAmount, tableFullAmount],
            ],
          },
        },
        {
          columns: [
            {
              style: "bodyFooter",
              margin: [9, 0, 0, 0],
              text: "ในกรณีที่ไม่สามารถดำเนินการจดทะเบียนรถยนต์ใช้แล้วเป็นชื่อผู้บริโภคหรือไม่สามารถส่งมอบรถยนต์ใช้แล้วให้ผู้บริโภคหรือมีการบอกเลิกสัญญา ขายรถยนต์ใช้แล้วโดยมิใช่ความผิดของผู้บริโภค ผู้ประกอบธุรกิจคืนเงินจำนวนดังกล่าวให้ผู้บริโภค",
            },
          ],
          columnGap: 1,
          lineHeight: 1,
          margin: [0, 8, 0, 0],
        },
        {
          table: {
            widths: ["33%", "33%", "33%"],
            body: [
              [
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "ลงชื่อ........................................................................",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "ลงชื่อ........................................................................",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: "ลงชื่อ........................................................................",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: " (....................................................................)",
                  style: "normalSign",
                  border: [false, false, false, false],
                  margin: [9, 0, 0, 0],
                },
                {
                  text: " (....................................................................)",
                  style: "normalSign",
                  border: [false, false, false, false],
                  margin: [9, 0, 0, 0],
                },
                {
                  text: " (....................................................................)",
                  style: "normalSign",
                  border: [false, false, false, false],
                  margin: [9, 0, 0, 0],
                },
              ],
              [
                {
                  text: " ผู้ซื้อ ",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: " ผู้ขาย ",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
                {
                  text: " ผู้มีอำนาจออกหลักฐานการรับเงิน ",
                  style: "normalSign",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          lineHeight: 0.7,
        },
      ],

      styles: {
        bodyhead: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        bodyFooter: {
          fontSize: 16,
          bold: true,
          alignment: "left",
        },
        sellerHead: {
          fontSize: 15,
          bold: true,
        },
        head: {
          fontSize: 19,
          bold: true,
          alignment: "center",
        },
        head2: {
          fontSize: 17,
          bold: true,
          alignment: "center",
        },
        normal: {
          fontSize: 15,
        },
        normalMini: {
          fontSize: 14,
        },
        normalSign: {
          fontSize: 14,
          bold: true,
          alignment: "center",
        },
        normalBold: {
          fontSize: 15,
          bold: true,
          //decoration : 'underline',
        },
        normalBig: {
          fontSize: 17,
        },
        normalBigBold: {
          fontSize: 17,
          bold: true,
        },
        normalRight: {
          fontSize: 15,
          alignment: "right",
        },
        normalLeft: {
          fontSize: 15,
          alignment: "left",
        },
        normalCenter: {
          fontSize: 15,
          alignment: "center",
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  printContractOcpd() {
    const { carBase64Img } = this.state;
    let buyer_name = this.state.buyer_name;
    let buyer_address = this.state.buyer_address;
    let obligation = this.state.obligation;
    let possessor = this.state.possessor;
    let ownership = this.state.ownership;
    let some_amount = this.state.some_amount;
    let full_amount = this.state.full_amount;
    let pay_type = this.state.pay_type;

    let seller_name = this.state.seller_name;
    let seller_address = this.state.seller_address;
    let seller_name2 = this.state.seller_name2;
    let seller_address2 = this.state.seller_address2;

    let car_brand_name = this.state.car_brand_name;
    let car_model_name = this.state.car_model_name;
    let car_num_engines = this.state.car_num_engines;
    let car_year_name = this.state.car_year_name;
    let car_color_name = this.state.car_color_name;
    let car_license_plate = this.state.car_license_plate;
    let car_number = this.state.car_number;
    let car_miles = this.state.car_miles;
    let province_name = this.state.province_name;

    let receipt_date_ocpd = this.state.receipt_date_ocpd;
    let handbook_copy_date = this.state.handbook_copy_date;
    let handbook_date = this.state.handbook_date;
    let car_date_delivery = this.state.car_date_delivery;

    let receipt_date_ocpd_thai = this.state.receipt_date_ocpd_thai;
    let handbook_copy_date_thai = this.state.handbook_copy_date_thai;
    let car_date_delivery_thai = this.state.car_date_delivery_thai;
    let handbook_date_thai = this.state.handbook_date_thai;

    let write_at = this.state.write_at;
    let car_name = this.state.car_name;
    let car_name2 = car_brand_name + " " + car_model_name;
    let real_sell_price = this.state.real_sell_price;
    let car_size_engine = this.state.car_size_engine;
    let car_equipment = this.state.car_equipment;
    let car_sufferers = this.state.car_sufferers;
    let part_payment_date_thai = this.state.part_payment_date_thai;
    let full_payment_date_thai = this.state.full_payment_date_thai;
    let pay_method = this.state.pay_method;
    let pay_method_detail = this.state.pay_method_detail;

    let pay_method_type;
    if (pay_method === "cash") {
      pay_method_type = "เงินสด";
    } else if (pay_method === "transfer") {
      pay_method_type = "เงินโอน";
    } else if (pay_method === "cheque") {
      pay_method_type = "เช็ค" + "  " + pay_method_detail;
    } else if (pay_method === "" || pay_method === null) {
      pay_method_type = null;
    }
    let location_delivery = this.state.location_delivery;
    let send_car_date_thai = this.state.send_car_date_thai;
    let request_loan = this.state.request_loan;
    let send_doc = this.state.send_doc;
    let other_note = this.state.other_note;

    let sign_seller =
      this.state.sign_seller === null || this.state.sign_seller === ""
        ? "(....................................................)"
        : "( " + this.state.sign_seller + " )";
    let sign_buyer =
      this.state.sign_buyer === null || this.state.sign_buyer === ""
        ? "(......................................................)"
        : "( " + this.state.sign_buyer + " )";
    let sign_evidence =
      this.state.sign_evidence === null || this.state.sign_evidence === ""
        ? "(......................................................)"
        : "( " + this.state.sign_evidence + " )";
    let sign_witness1 =
      this.state.sign_witness1 === null || this.state.sign_witness1 === ""
        ? "(......................................................)"
        : "( " + this.state.sign_witness1 + " )";
    let sign_witness2 =
      this.state.sign_witness2 === null || this.state.sign_witness2 === ""
        ? "(......................................................)"
        : "( " + this.state.sign_witness2 + " )";

    let write_at_pad = stringUtil.addSpacePaddingFill(write_at, 56);
    let receipt_date_ocpd_thai_pad = stringUtil.addSpacePaddingFill(
      receipt_date_ocpd_thai,
      30
    );
    let seller_name_pad = stringUtil.addSpacePaddingFill(seller_name, 56);
    let seller_address_pad = stringUtil.addSpacePaddingFill(seller_address, 56);
    let buyer_name_pad = stringUtil.addSpacePaddingFill(buyer_name, 42);
    let buyer_address_pad = stringUtil.addSpacePaddingFill(buyer_address, 60);
    let car_name_pad = stringUtil.addSpacePaddingFill(car_name2, 50);
    let real_sell_price_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(real_sell_price, 10)),
      24
    );
    let car_brand_name_pad = stringUtil.addSpacePaddingFill(car_brand_name, 26);
    let car_model_name_pad = stringUtil.addSpacePaddingFill(car_model_name, 26);
    let car_year_name_pad = stringUtil.addSpacePaddingFill(car_year_name, 12);
    let car_color_name_pad = stringUtil.addSpacePaddingFill(car_color_name, 22);
    let car_num_engines_pad = stringUtil.addSpacePaddingFill(
      car_num_engines,
      30
    );
    let car_number_pad = stringUtil.addSpacePaddingFill(car_number, 30);
    let car_license_pad = stringUtil.addSpacePaddingFill(car_license_plate, 44);
    let province_name_pad = stringUtil.addSpacePaddingFill(province_name, 24);
    let car_miles_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommasZeroInt(String(car_miles)),
      22
    );
    let car_size_engine_pad = stringUtil.addSpacePaddingFill(
      car_size_engine,
      30
    );
    let obligation_pad = stringUtil.addSpacePaddingFill(obligation, 46);
    let car_equipment_pad = stringUtil.addSpacePaddingFill(car_equipment, 80);
    let car_sufferers_pad = stringUtil.addSpacePaddingFill(car_sufferers, 86);
    let ownership_pad = stringUtil.addSpacePaddingFill(ownership, 42);
    let possessor_pad = stringUtil.addSpacePaddingFill(possessor, 42);
    let part_payment_date_thai_pad = stringUtil.addSpacePaddingFill(
      part_payment_date_thai,
      28
    );
    let some_amount_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(some_amount, 10)),
      24
    );
    let handbook_copy_date_thai_pad = stringUtil.addSpacePaddingFill(
      handbook_copy_date_thai,
      28
    );
    let full_payment_date_thai_pad = stringUtil.addSpacePaddingFill(
      full_payment_date_thai,
      28
    );
    let full_amount_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(full_amount, 10)),
      24
    );
    let pay_method_pad = stringUtil.addSpacePaddingFill(pay_method_type, 30);
    let handbook_date_thai_pad = stringUtil.addSpacePaddingFill(
      handbook_date_thai,
      28
    );
    let car_date_delivery_thai_pad = stringUtil.addSpacePaddingFill(
      car_date_delivery_thai,
      28
    );
    let location_delivery_pad = stringUtil.addSpacePaddingFill(
      location_delivery,
      60
    );
    let send_car_date_thai_pad = stringUtil.addSpacePaddingFill(
      send_car_date_thai,
      28
    );
    let request_loan_pad = stringUtil.addSpacePaddingFill(request_loan, 10);
    let send_doc_pad = stringUtil.addSpacePaddingFill(send_doc, 10);
    let other_note_pad = stringUtil.addSpacePaddingFill(other_note, 60);

    let thaibathSomeAmount = "(" + ThaiBaht(some_amount) + ")";
    if (some_amount === 0) {
      thaibathSomeAmount = "(                                  )";
    }

    let thaibathFullAmount = "(" + ThaiBaht(full_amount) + ")";
    if (full_amount === 0) {
      thaibathFullAmount = "(                                  )";
    }

    let headerLeft;
    let headerCenter;

    let some_text =
      "..................................................................................";

    if (some_amount > 0) {
      some_text =
        NumberUtil.addCommas(parseInt(some_amount, 10)) +
        " " +
        " บาท " +
        " " +
        "(..." +
        ThaiBaht(some_amount) +
        "...)";
    }

    let full_text =
      "..................................................................................";

    if (full_amount > 0) {
      full_text =
        NumberUtil.addCommas(parseInt(full_amount, 10)) +
        " " +
        " บาท " +
        " " +
        "(..." +
        ThaiBaht(full_amount) +
        "...)";
    }

    headerLeft = {
      image: carBase64Img,
      width: 80,
    };
    //headerCenter = ' หลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว'

    let tableHeader = {
      table: {
        widths: ["20%", "60%", "20%"],
        body: [
          ["", { text: " สัญญาซื้อขายรถยนต์ ", style: "head" }, ""],
          [
            "",
            {
              text: " และหลักฐานการรับเงินการจำหน่ายรถยนต์ใช้แล้ว ",
              style: "head",
            },
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.9,
      margin: [0, 0, 0, 5],
    };

    let tableTitle = {
      table: {
        widths: ["17%", "40%", "8%", "*"],
        body: [
          [
            { text: "สัญญานี้ทำขึ้นที่ ", style: "normal" },
            { text: write_at_pad, style: ["normal", "bottomLine"] },
            { text: "วันที่ ", style: "normal" },
            {
              text: receipt_date_ocpd_thai_pad,
              style: ["normalMini", "bottomLine"],
            },
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.9,
    };

    let tableSeller1 = {
      table: {
        widths: ["16%", "*"],
        body: [
          [
            {
              text: "ชื่อ/ที่อยู่ ของผู้ประกอบธุรกิจ (ผู้ขาย)",
              style: "sellerHead",
              border: [false, false, false, false],
              colSpan: 2,
            },
            "",
          ],
          [
            {
              text: "บริษัท ",
              style: "normal",
              border: [false, false, false, false],
            },
            {
              text: seller_name,
              style: ["normal", "bottomLine"],
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "ที่อยู่ ",
              style: "normal",
              border: [false, false, false, false],
            },
            {
              text: seller_address,
              style: ["normal", "bottomLine"],
              border: [false, false, false, false],
            },
          ],
        ],
      },
      lineHeight: 0.75,
    };

    let tableSeller2 = {
      table: {
        widths: ["16%", "*"],
        body: [
          [
            {
              text: "ชื่อ/ที่อยู่ ของผู้มีอำนาจออกหลักฐานการรับเงิน",
              style: "sellerHead",
              border: [false, false, false, false],
              colSpan: 2,
            },
            "",
          ],
          [
            {
              text: "บริษัท ",
              style: "normal",
              border: [false, false, false, false],
            },
            {
              text: seller_name2,
              style: ["normal", "bottomLine"],
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "ที่อยู่ ",
              style: "normal",
              border: [false, false, false, false],
            },
            {
              text: seller_address2,
              style: ["normal", "bottomLine"],
              border: [false, false, false, false],
            },
          ],
        ],
      },
      lineHeight: 0.75,
    };

    let tableBuyer = {
      table: {
        widths: ["100%"],
        body: [
          [{ text: "ชื่อ/ที่อยู่ของลูกค้า (ผู้ซื้อ)", style: "normalBigBold" }],
          [{ text: "ชื่อ...." + buyer_name + "......", style: "normalBig" }],
          [
            {
              text: "ที่อยู่...." + buyer_address + "......",
              style: "normalBig",
            },
          ],
        ],
      },
      layout: "noBorders",
      //border: [false, true, false, false],
      margin: [8, 0, 0, 0],
    };

    let tableCarDetail = {
      table: {
        widths: ["30%", "70%"],
        body: [
          [{ text: "รายละเอียดรถยนต์", style: "normalBold" }, ""],
          [
            {
              text: "ยี่ห้อ........" + car_brand_name + "........",
              style: "normal",
              width: "30%",
            },
            {
              text: "หมายเลขเครื่องยนต์........" + car_num_engines + "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "รุ่น..........." + car_model_name + "........",
              style: "normal",
              width: "30%",
            },
            {
              text: "หมายเลขตัวถัง..............." + car_number + "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "ปี............." + car_year_name + "..................",
              style: "normal",
              width: "30%",
            },
            {
              text:
                "หมายเลขทะเบียน.........." +
                car_license_plate +
                "  " +
                province_name +
                "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text: "สี............." + car_color_name + "..................",
              style: "normal",
              width: "32%",
            },
            {
              text:
                "ระยะทางการใช้รถยนต์.........." +
                car_miles +
                "..." +
                "กิโลเมตร" +
                "........",
              style: "normal",
              width: "70%",
            },
          ],
          [
            {
              text:
                "ภาระผูกพัน (ถ้ามี)......................................." +
                obligation +
                "............................................",
              style: "normal",
              colSpan: 2,
            },
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.75,
      //border: [false, true, true, false]
    };

    let tablePossessor = {
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text: "ผู้ถือกรรมสิทธิ์......" + ownership + "......",
              style: "normalBig",
              colspan: 3,
            },
          ],
          [
            {
              text: "ผู้ครอบครอง........." + possessor + "......",
              style: "normalBig",
              colspan: 3,
            },
          ],
        ],
      },
      layout: "noBorders",
      //border: [false, true, false, false],
      margin: [8, 32, 0, 0],
    };

    let tableSomeAmount = {
      table: {
        widths: ["90%", "10%"],
        body: [
          [{ text: "กรณีชำระเงินค่ารถยนต์บางส่วน", style: "normalBold" }, ""],
          [
            {
              text: "๑. จำนวนเงิน..." + some_text,
              style: "normal",
              colspan: 2,
            },
            "",
          ],
          [
            {
              text:
                "๒. ผู้ขายตกลงส่งมอบสำเนาสมุดคู่มือจดทะเบียนรถยนต์ ในวันที่..." +
                handbook_copy_date_thai +
                "...",
              style: "normal",
              colspan: 2,
            },
            "",
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.8,
      //border: [false, true, true, true]
    };

    let tableFullAmount = {
      table: {
        widths: ["100%"],
        body: [
          [{ text: "กรณีชำระเงินค่ารถยนต์ครบถ้วน", style: "normalBold" }],
          [{ text: "๑. จำนวนเงิน..." + full_text, style: "normal" }],
          [
            {
              text:
                "๒. ผู้ขายตกลงส่งมอบรถยนต์ ในวันที่..." +
                car_date_delivery_thai +
                "...",
              style: "normal",
            },
          ],
          [
            {
              text:
                "๓. ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถยนต์พร้อมเอกสารที่จำเป็นสำหรับ การจดทะเบียนรถยนต์ ตามที่กรมการขนส่งทางบกกำหนดให้กับผู้ซื้อ ในวันที่..." +
                handbook_date_thai +
                "...",
              style: "normal",
            },
          ],
        ],
      },
      layout: "noBorders",
      lineHeight: 0.8,
      //border: [false, true, false, true]
    };

    const pageBreak = {
      text: "",
      style: "contentCenterBold",
      pageBreak: "before",
      pageOrientation: "portrait",
      margin: [0, 0, 0, 15],
    };

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [45, 25, 45, 0],
      content: [
        tableHeader,
        tableTitle,
        {
          table: {
            widths: ["50%", "50%"],
            body: [[tableSeller1, tableSeller2]],
          },
          //layout: 'noBorders',
          border: [false, false, true, false],
        },
        {
          columns: [
            {
              width: "*",
              style: "sellerHead",
              text: "ชื่อ/ที่อยู่ของลูกค้า (ผู้ซื้อ)",
            },
          ],
          columnGap: 10,
          margin: [0, 5, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "5%", style: "normal", text: "ชื่อ" },
            {
              width: "35%",
              style: ["normal", "bottomLine"],
              text: buyer_name_pad,
            },
            { width: "7%", style: "normal", text: "ที่อยู่" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: buyer_address_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 12],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "49%",
              style: "normalBold",
              text: "ข้อ 1. ผู้ซื้อตกลงซื้อ และผู้ขายตกลงขายรถยนต์ประเภท",
            },
            {
              width: "35%",
              style: ["normal", "bottomLine"],
              text: car_name_pad,
            },
            { width: "*", style: "normal", text: "ทั้งสองฝ่ายตกลงซื้อขาย" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "37%",
              style: "normal",
              text: "รถยนต์ตามสัญญานี้ ในราคาทั้งสิ้นจำนวน",
            },
            {
              width: "15%",
              style: ["normal", "bottomLine"],
              text: real_sell_price_pad,
            },
            { width: "4%", style: "normal", text: "บาท" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: "(" + ThaiBaht(real_sell_price) + ")",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "*", style: "bottomLineTitle", text: "รายละเอียดรถยนต์" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "7%", style: "normal", text: "ยี่ห้อ" },
            {
              width: "20%",
              style: ["normal", "bottomLine"],
              text: car_brand_name_pad,
            },
            { width: "7%", style: "normal", text: "รุ่น" },
            {
              width: "20%",
              style: ["normal", "bottomLine"],
              text: car_model_name_pad,
            },
            { width: "7%", style: "normal", text: "ปี" },
            {
              width: "10%",
              style: ["normal", "bottomLine"],
              text: car_year_name_pad,
            },
            { width: "7%", style: "normal", text: "สี" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_color_name_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "20%", style: "normal", text: "หมายเลขเครื่องยนต์" },
            {
              width: "26%",
              style: ["normal", "bottomLine"],
              text: car_num_engines_pad,
            },
            { width: "20%", style: "normal", text: "หมายเลขตัวถัง" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_number_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "18%", style: "normal", text: "หมายเลขทะเบียน" },
            {
              width: "11%",
              style: ["normal", "bottomLine"],
              text: car_license_pad,
            },
            { width: "17%", style: ["normal"], text: province_name_pad },
            { width: "23%", style: ["normal"], text: "ระยะทางการใช้รถยนต์" },
            {
              width: "14%",
              style: ["normal", "bottomLine"],
              text: car_miles_pad,
            },
            { width: "*", style: ["normal"], text: "กิโลเมตร" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "20%", style: "normal", text: "ขนาดกำลังเครื่องยนต์" },
            {
              width: "21%",
              style: ["normal", "bottomLine"],
              text: car_size_engine_pad,
            },
            { width: "17%", style: "normal", text: "ภาระผูกพัน (ถ้ามี)" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: obligation_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "29%",
              style: "normal",
              text: "อุปกรณ์ที่ติดมากับรถยนต์ (ถ้ามี)",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_equipment_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "25%",
              style: "normal",
              text: "ข้อมูลการประสบภัย (ถ้ามี)",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_sufferers_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", style: "normal", text: "ผู้ถือกรรมสิทธิ์" },
            {
              width: "32%",
              style: ["normal", "bottomLine"],
              text: ownership_pad,
            },
            { width: "14%", style: "normal", text: "ผู้ครอบครอง" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: possessor_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            { width: "*", style: "normalBold", text: "ข้อ 2. การชำระเงิน" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "4%", style: "normal", text: "2.1)" },
            { width: "6%", style: "normal", text: "วันที่ " },
            {
              width: "21%",
              style: ["normal", "bottomLine"],
              text: part_payment_date_thai_pad,
            },
            {
              width: "*",
              style: ["normal"],
              text: "ชำระเงินค่ารถยนต์บางส่วน เงินจอง/เงินมัดจำ/เงินดาวน์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "12%", style: "normal", text: "จำนวนเงิน" },
            {
              width: "15%",
              style: ["normal", "bottomLine"],
              text: some_amount_pad,
            },
            { width: "4%", style: "normal", text: "บาท" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: thaibathSomeAmount,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "2%", style: "normal", text: "☐" },
            {
              width: "48%",
              style: "normal",
              text: "ผู้ขายตกลงส่งมอบสำเนาคู่มือจดทะเบียนรถยนต์ ในวันที่",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: handbook_copy_date_thai_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "4%", style: "normal", text: "2.2)" },
            { width: "6%", style: "normal", text: "วันที่ " },
            {
              width: "21%",
              style: ["normal", "bottomLine"],
              text: full_payment_date_thai_pad,
            },
            {
              width: "38%",
              style: ["normal"],
              text: "ชำระเงินค่ารถยนต์ครบถ้วน จำนวนเงิน",
            },
            {
              width: "15%",
              style: ["normal", "bottomLine"],
              text: full_amount_pad,
            },
            { width: "4%", style: "normal", text: "บาท" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "50%",
              style: ["normal", "bottomLine"],
              text: thaibathFullAmount,
            },
            { width: "11%", style: ["normal"], text: "โดยชำระเป็น" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: pay_method_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "2%", style: "normal", text: "☐" },
            {
              width: "*",
              style: "normal",
              text: "ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถยนต์พร้อมเอกสารที่จำเป็นสำหรับการจดทะเบียนรถยนต์ตามที่",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "40%",
              style: "normal",
              text: "กรมการขนส่งทางบกกำหนดให้กับผู้ซื้อ ในวันที่",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: handbook_date_thai_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "*",
              style: "normalBold",
              text: "ข้อ 3. กำหนดส่งมอบรถยนต์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "ผู้ขายจะได้ทำการส่งมอบรถให้กับผู้ซื้อ ในสภาพเรียบร้อยตรงตามวัตถุประสงค์ของผู้ซื้อทุกประการ  และให้ถือว่า",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "50%",
              style: "normal",
              text: "กรรมสิทธิ์ในรถยนต์ได้โอนให้กับผู้ซื้อเรียบร้อยแล้ว ในวันที่",
            },
            {
              width: "21%",
              style: ["normal", "bottomLine"],
              text: car_date_delivery_thai_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            { width: "13%", style: "normal", text: "ณ สถานที่" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: location_delivery_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถพร้อมเอกสารที่จำเป็นสำหรับการจดทะเบียนรถยนต์ตามที่กรมการขนส่งทางบก",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "24%",
              style: "normal",
              text: "กำหนดให้กับผู้ซื้อ  ในวันที่",
            },
            {
              width: "21%",
              style: ["normal", "bottomLine"],
              text: send_car_date_thai_pad,
            },
            {
              width: "*",
              style: "normal",
              text: "เมื่อมีการปฏิบัติตามสัญญากันครบถ้วนแล้ว",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        pageBreak,
        {
          columns: [
            {
              width: "25%",
              style: "normalBold",
              text: "ข้อ 4. การบอกกล่าว ทวงถาม",
            },
            {
              width: "*",
              style: "normal",
              text: "หรือส่งเอกสารใดๆ อันพึงมีไปยังคู่สัญญาอีกฝ่ายหนึ่งตามภูมิลำเนาที่ปรากฏในสัญญานี้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ให้ถือว่าเป็นการส่งโดยชอบ และคู่สัญญาอีกฝ่ายได้ทราบแล้วในวันที่คำบอกกล่าว หรือเอกสารนั้นๆ พึงไปถึงตามปกติ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "30%",
              style: "normalBold",
              text: "ข้อ 5. ผู้บริโภคมีสิทธิบอกเลิกสัญญา",
            },
            {
              width: "*",
              style: "normal",
              text: "เมื่อผู้ประกอบธุรกิจกระทำการอย่างใดอย่างหนึ่ง ดังต่อไปนี้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "5.1) มีการปรับเปลี่ยนราคารถยนต์สูงขึ้นจากที่ตกลงกันไว้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "5.2) ไม่ส่งมอบรถยนต์ให้กับผู้บริโภคภายในระยะเวลาที่กำหนด",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "5.3) ส่งมอบรถยนต์ที่มี ยี่ห้อ รุ่น ปี สี หมายเลขเครื่องยนต์ หมายเลขตัวถัง ขนาดกำลังเครื่องยนต์ หมายเลขทะเบียน",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "และอุปกรณ์ที่ติดมากับรถยนต์ (ถ้ามี) รวมถึงระยะทางที่ได้ใช้แล้ว โดยให้มีหน่วยเป็นกิโลเมตรหรือไมล์ ไม่ถูกต้องตามที่ตกลง",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [{ width: "*", style: "normal", text: "กันไว้ในสัญญา" }],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "5.4) ไม่สามารถดำเนินการจดทะเบียนรถยนต์ให้เป็นชื่อของผู้บริโภคตามสัญญา",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "ทั้งนี้ ผู้บริโภคที่ทำการบอกกล่าวเลิกสัญญาตามข้อ 5 จะต้องทำเป็นหนังสือบอกกล่าวขอเลิกสัญญาโดยอ้างเหตุผล",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ข้อใดข้อหนึ่งหรือหลายข้อข้างต้น พร้อมนำส่งหนังสือให้กับผู้ประกอบการธุรกิจ โดยจะต้องมีหลักฐานที่ผู้ประกอบธุรกิจได้รับ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [{ width: "*", style: "normal", text: "หนังสือนั้นแล้ว" }],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "45%",
              style: "normalBold",
              text: "ข้อ 6. เมื่อผู้บริโภคมีการบอกเลิกสัญญาตามข้อ 5 แล้ว",
            },
            {
              width: "*",
              style: "normal",
              text: "ผู้ประกอบธุรกิจต้องคืนเงินหรือสิ่งใดที่ได้รับไว้ทั้งหมดแก่ผู้บริโภคภายใน",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "สิบห้าวันนับแต่วันที่ผู้ประกอบธุรกิจได้รับหนังสือบอกเลิกสัญญาจากผู้บริโภค",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "46%",
              style: "normalBold",
              text: "ข้อ 7. ในกรณีที่ไม่สามารถดำเนินการจดทะเบียนรถยนต์",
            },
            {
              width: "*",
              style: "normal",
              text: "ใช้แล้วเป็นชื่อผู้บริโภคหรือไม่สามารถส่งมอบรถยนต์ใช้แล้วให้ผู้บริโภค",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "หรือมีการบอกเลิกสัญญาขายรถยนต์ใช้แล้วโดยมิใช่ความผิดของผู้บริโภค ผู้ประกอบธุรกิจจะคืนเงินที่ได้รับไว้แล้วทั้งหมด",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [{ width: "*", style: "normal", text: "ให้กับผู้บริโภค" }],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "*",
              style: "normalBold",
              text: "ข้อ 8. ผู้ประกอบธุกิจมีสิทธิบอกเลิกสัญญา เมื่อปรากฏข้อเท็จจริงข้อใดข้อหนึ่งดังต่อไปนี้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "4%", style: "normalItalic", text: "8.1) " },
            {
              width: "*",
              style: "normalItalicLine",
              text: "ผู้บริโภคไม่ชำระหนี้ตามกำหนด",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "4%", style: "normalItalic", text: "8.2) " },
            {
              width: "*",
              style: "normalItalicLine",
              text: "ผู้บริโภคผิดสัญญาหรือผิดเงื่อนไขอันเป็นสาระสำคัญ ได้แก่",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "8%", style: "normal", text: "" },
            { width: "3%", style: "normalItalic", text: "(1) " },
            {
              width: "58%",
              style: "normalItalicLine",
              text: "ผู้บริโภคไม่ดำเนินการติดต่อสถาบันการเงินเพื่อขอสินเชื่อภายใน",
            },
            {
              width: "4%",
              style: ["normalItalicLine", "bottomLine"],
              text: request_loan_pad,
            },
            { width: "4%", style: "normalItalicLine", text: "วัน" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "8%", style: "normal", text: "" },
            { width: "3%", style: "normalItalic", text: "(2)" },
            {
              width: "*",
              style: "normalItalicLine",
              text: "ผู้บริโภคไม่จัดส่งเอกสารให้กับผู้ประกอบธุรกิจหรือสถาบันการเงินที่ผู้ประกอบธุรกิจได้ประสารติดต่อภายใน",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            { width: "8%", style: "normalItalicLine", text: "กำหนด" },
            {
              width: "4%",
              style: ["normalItalicLine", "bottomLine"],
              text: send_doc_pad,
            },
            {
              width: "*",
              style: "normalItalicLine",
              text: "วัน โดยไม่แจ้งเหตุผลให้ทราบ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "8%", style: "normal", text: "" },
            { width: "3%", style: "normalItalic", text: "(3)" },
            {
              width: "*",
              style: "normalItalicLine",
              text: "ผู้บริโภคเปลี่ยนใจไม่ต้องการรถยนต์คันที่จองหรือมัดจำไว้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "8%", style: "normal", text: "" },
            { width: "3%", style: "normalItalic", text: "(4)" },
            {
              width: "17%",
              style: "normalItalicLine",
              text: "อื่นๆ (ถ้ามี ระบุ)",
            },
            {
              width: "*",
              style: ["normalItalicLine", "bottomLine"],
              text: other_note_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "การบอกเลิกสัญญา ผู้ประกอบธุรกิจจะต้องมีหนังสือบอกกล่าวให้ผู้บริโภคปฏิบัติตามสัญญาแล้วเป็นเวลาไม่น้อยกว่า",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "สิบห้าวันนับแต่วันที่ผู้บริโภคได้รับหนังสือ และผู้บริโภคละเลยเสียไม่ปฏิบัติตามหนังสือบอกกล่าวนั้น",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          columns: [
            {
              width: "*",
              style: "normalBold",
              text: "ข้อ 9. ผู้ประกอบธุรกิจไม่มีสิทธิ์ริบเงินทั้งหมด หรือบางส่วน เว้นแต่ผู้บริโภคเป็นฝ่ายผิดสัญญา",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "4%", style: "normal", text: "" },
            {
              width: "*",
              style: "normal",
              text: "สัญญานี้ทำขึ้นเป็นสองฉบับ มีข้อความถูกต้องตรงกัน ทั้งสองฝ่ายได้ทราบและเข้าใจข้อความโดยตลอดดีแล้ว เห็นว่าตรงตาม",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "เจตนาของตน จึงได้ลงลายมือชื่อ และประทับตรา (ถ้ามี) ไว้เป็นสำคัญต่อหน้าพยาน และต่างยึดถือไว้ฝ่ายละฉบับ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },
        {
          columns: [{ width: "*", style: "normal", text: "" }],
          columnGap: 10,
          margin: [0, 0, 0, 0],
          lineHeight: 1,
        },

        {
          table: {
            widths: ["33%", "33%", "34%"],
            body: [
              [
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
              ],
              [
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
              ],
              [
                {
                  text: "ลงชื่อ....................................................",
                  style: "normalSign",
                },
                {
                  text: "ลงชื่อ..................................................",
                  style: "normalSign",
                },
                {
                  text: "ลงชื่อ....................................................",
                  style: "normalSign",
                },
              ],
              [
                {
                  text: sign_buyer,
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
                {
                  text: sign_seller,
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
                {
                  text: sign_evidence,
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
              ],
              [
                {
                  text: " ผู้ซื้อ ",
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
                {
                  text: " ผู้ขาย ",
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
                {
                  text: " (ผู้มีอำนาจออกหลักฐานการรับเงิน) ",
                  style: "normalSign",
                  margin: [15, 0, 0, 0],
                },
              ],
            ],
          },
          lineHeight: 0.9,
          layout: "noBorders",
          margin: [0, 20, 0, 10],
        },
        {
          table: {
            widths: ["40%", "40%"],
            body: [
              [
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
              ],
              [
                { text: "", style: "normalSign" },
                { text: "", style: "normalSign" },
              ],
              [
                {
                  text: "ลงชื่อ.........................................................พยาน",
                  style: "normalSign",
                },
                {
                  text: "ลงชื่อ.......................................................พยาน",
                  style: "normalSign",
                },
              ],
              [
                {
                  text: sign_witness1,
                  style: "normalSign",
                  margin: [5, 0, 0, 0],
                },
                {
                  text: sign_witness2,
                  style: "normalSign",
                  margin: [5, 0, 0, 0],
                },
              ],
            ],
          },
          lineHeight: 0.9,
          layout: "noBorders",
        },
      ],

      styles: {
        bodyhead: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        bodyFooter: {
          fontSize: 16,
          bold: true,
          alignment: "left",
        },
        sellerHead: {
          fontSize: 15,
          bold: true,
        },
        head: {
          fontSize: 17,
          bold: true,
          alignment: "center",
        },
        head2: {
          fontSize: 17,
          bold: true,
          alignment: "center",
        },
        normal: {
          fontSize: 15,
        },
        normalItalic: {
          fontSize: 15,
          italics: true,
          bold: true,
        },
        normalItalicLine: {
          fontSize: 15,
          decoration: "underline",
          italics: true,
          bold: true,
        },
        normalMini: {
          fontSize: 14,
        },
        normalSign: {
          fontSize: 15,
          bold: true,
          alignment: "center",
        },
        normalBold: {
          fontSize: 15,
          bold: true,
          //decoration : 'underline',
        },
        normalBig: {
          fontSize: 17,
        },
        normalBigBold: {
          fontSize: 17,
          bold: true,
        },
        normalRight: {
          fontSize: 15,
          alignment: "right",
        },
        normalLeft: {
          fontSize: 15,
          alignment: "left",
        },
        normalCenter: {
          fontSize: 15,
          alignment: "center",
        },
        bottomLine: {
          decoration: "underline",
          decorationStyle: "dotted",
        },
        bottomLineTitle: {
          decoration: "underline",
          fontSize: 15,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  render() {
    return (
      <div className="row">
        <Loading isLoading={this.state.isLoading} />

        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <strong className="text-title">
                สัญญาซื้อขายรถยนต์ และหลักฐานการรับเงินการจำหน่ายรถยนต์ใช้แล้ว
              </strong>
              {/*<strong className="text-title">หลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว</strong>*/}
            </div>

            <div
              className="card-block"
              style={{ paddingLeft: 80, paddingRight: 80, paddingTop: 10 }}
            >
              <div className="row" style={{ lineHeight: 3.0 }}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        &nbsp;
                      </td>
                      <td style={styles.tdContentCenter}>
                        {/*<strong className="text-title" style={{fontSize: 18}}> หลักฐานการรับเงิน ธุรกิจการขายรถยนต์ใช้แล้ว </strong>*/}
                        <strong className="text-title">
                          สัญญาซื้อขายรถยนต์
                          และหลักฐานการรับเงินการจำหน่ายรถยนต์ใช้แล้ว
                        </strong>
                      </td>
                      <td width={"30%"}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-5 ml-5 mb-2">
                          <span>สัญญาทำขึ้น ณ </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputDataWriteAt}
                            value={this.state.write_at || ""}
                            onChange={(e) => {
                              this.setState({
                                write_at: e.target.value,
                              });
                            }}
                          />

                          <span className="mr-3">เมื่อวันที่</span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.receipt_date_ocpd_thai === null
                                ? ""
                                : this.state.receipt_date_ocpd_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startDateReceiptOcpd}
                              onChange={this.handleDateReceiptOcpd}
                              dateFormat="yyyy-MM-dd"
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span className="mr-3">
                            ชื่อ/ที่อยู่ ของผู้ประกอบธุรกิจ (ผู้ขาย)
                          </span>
                          &nbsp;
                          <input
                            className="form-control ml-5"
                            style={{ width: "20%", borderRadius: "5px" }}
                            name="seller_name"
                            value={this.state.seller_name}
                            onChange={this.handleOnChange}
                          />
                          &nbsp;
                          {/*<span style={{width: 50, textAlign: 'center'}} >ที่อยู่</span>*/}
                          <input
                            className="form-control ml-2"
                            style={styles.inputLong}
                            name="seller_address"
                            value={this.state.seller_address}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span>
                            ชื่อ/ที่อยู่ ของผู้มีอำนาจออกหลักฐานการรับเงิน
                          </span>
                          <input
                            className="form-control ml-3"
                            style={{ width: "20%", borderRadius: "5px" }}
                            name="seller_name2"
                            value={this.state.seller_name2}
                            onChange={this.handleOnChange}
                          />
                          &nbsp;
                          {/*<span style={{width: 50, textAlign: 'center'}} >ที่อยู่</span>*/}
                          <input
                            className="form-control ml-2"
                            style={styles.inputLong}
                            name="seller_address2"
                            value={this.state.seller_address2}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span style={{ paddingRight: "9%" }}>
                            ชื่อ/ที่อยู่ของลูกค้า (ผู้ซื้อ)
                          </span>
                          <input
                            className="form-control"
                            style={{ width: "20%", borderRadius: "5px" }}
                            name="buyer_name"
                            value={this.state.buyer_name}
                            onChange={this.handleOnChange}
                          />
                          &nbsp;
                          {/*<span style={{width: 50, textAlign: 'center'}} >ที่อยู่</span>*/}
                          <input
                            className="form-control ml-2"
                            style={styles.inputLong}
                            name="buyer_address"
                            value={this.state.buyer_address}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-3">
                          <strong className="text-title">
                            <span>
                              ข้อ 1. ผู้ซื้อตกลงซื้อ
                              และผู้ขายตกลงขายรถยนต์ประเภท
                            </span>
                          </strong>
                          <input
                            className="form-control ml-3 mr-2"
                            style={{ width: "30%", borderRadius: "5px" }}
                            name="car_name"
                            value={this.state.car_name}
                            onChange={this.handleOnChange}
                          />
                          <span>ทั้งสองฝ่ายตกลงซื้อขายรถยนต์</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span>ตามสัญญานี้ ในราคาทั้งสิ้นจำนวน</span>
                          <NumberFormat
                            className="form-control ml-3 mr-2"
                            style={{ width: "20%", borderRadius: "5px" }}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.real_sell_price}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ real_sell_price: value });
                            }}
                          />
                          <span style={{ width: 30 }} className="ml-3">
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.real_sell_price)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <span style={{ textDecoration: "underline" }}>
                          รายละเอียดรถยนต์
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>ยี่ห้อ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_brand_name"
                            value={this.state.car_brand_name}
                            onChange={this.handleOnChange}
                          />

                          <span>รุ่น</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_model_name"
                            value={this.state.car_model_name}
                            onChange={this.handleOnChange}
                          />

                          <span>ปี</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_year_name"
                            value={this.state.car_year_name}
                            onChange={this.handleOnChange}
                          />

                          <span>สี</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_color_name"
                            value={this.state.car_color_name}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>หมายเลขเครื่องยนต์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_num_engines"
                            value={this.state.car_num_engines}
                            onChange={this.handleOnChange}
                          />
                          <span>หมายเลขตัวถัง</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_number"
                            value={this.state.car_number}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>หมายเลขทะเบียน</span>&nbsp;
                          <input
                            className="form-control ml-4 mr-1"
                            style={styles.inputMedium}
                            name="car_license_plate"
                            value={this.state.car_license_plate}
                            onChange={this.handleOnChange}
                          />
                          <input
                            className="form-control ml-2 mr-3"
                            style={{ borderRadius: "5px", width: "130px" }}
                            name="province_name"
                            disabled
                            value={this.state.province_name}
                            //onChange={this.handleOnChange}
                          />
                          <span>ระยะทางการใช้รถยนต์</span>
                          <input
                            className="form-control ml-3 mr-1"
                            style={styles.inputMedium}
                            name="car_miles"
                            value={this.state.car_miles}
                            onChange={this.handleOnChange}
                          />
                          &nbsp;&nbsp; กิโลเมตร
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>ขนาดกำลังเครื่องยนต์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_size_engine"
                            value={this.state.car_size_engine}
                            onChange={this.handleOnChange}
                          />
                          <span>ภาระผูกพัน (ถ้ามี)</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="obligation"
                            value={this.state.obligation}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>อุปกรณ์ที่ติดมากับรถยนต์ (ถ้ามี)</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="car_equipment"
                            value={this.state.car_equipment}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>ข้อมูลการประสบภัย (ถ้ามี)</span>&nbsp;
                          <input
                            className="form-control ml-5 mr-3"
                            style={styles.inputLong}
                            name="car_sufferers"
                            value={this.state.car_sufferers}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    {/*{กรรมสิทธิ์}*/}
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>ผู้ถือกรรมสิทธิ์</span>
                          <input
                            className="form-control ml-5 mr-3"
                            style={{ width: "25%", borderRadius: "5px" }}
                            name="ownership"
                            value={this.state.ownership}
                            onChange={this.handleOnChange}
                          />
                          <span>ผู้ครอบครอง</span>
                          <input
                            className="form-control ml-4 mr-3"
                            style={{ width: "25%", borderRadius: "5px" }}
                            name="possessor"
                            value={this.state.possessor}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-3">
                          <strong className="text-title">
                            <span>ข้อ 2. การชำระเงิน</span>
                          </strong>
                          <div className="form-inline ml-5">
                            <div
                              className="btn-group colors"
                              style={{ height: 36 }}
                            >
                              <input
                                type="radio"
                                name="pay_type"
                                value="ชำระบางส่วน"
                                className="btn btn-primary"
                                checked={this.state.pay_type === "ชำระบางส่วน"}
                                onChange={this.onPayTypeChanged}
                              />
                              &nbsp;&nbsp;
                              <span style={{ marginTop: -4 }}>
                                ชำระเงินค่ารถยนต์บางส่วน
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <input
                                type="radio"
                                name="pay_type"
                                value="ชำระครบถ้วน"
                                className="btn btn-primary"
                                checked={this.state.pay_type === "ชำระครบถ้วน"}
                                onChange={this.onPayTypeChanged}
                              />{" "}
                              &nbsp;&nbsp;
                              <span style={{ marginTop: -4 }}>
                                ชำระเงินค่ารถยนต์ครบถ้วน
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <span style={{ textDecoration: "underline" }}>
                          กรณีชำระเงินค่ารถยนต์บางส่วน
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">2.1) วันที่</span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.part_payment_date_thai === null
                                ? ""
                                : this.state.part_payment_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startDatePartPayment}
                              onChange={this.handleDatePartPayment}
                              dateFormat="yyyy-MM-dd"
                              disable={this.state.pay_type === "ชำระครบถ้วน"}
                              type={"icon"}
                            />
                          </div>

                          <span className="ml-3">
                            ชำระเงินค่ารถยนต์บางส่วน เงินจอง/เงินมัดจำ/เงินดาวน์
                            จำนวนเงิน
                          </span>
                          <NumberFormat
                            className="form-control ml-3 mr-2"
                            style={styles.inputMedium}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.some_amount}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ some_amount: value });
                            }}
                            disabled={this.state.pay_type === "ชำระครบถ้วน"}
                          />
                          <span style={{ width: 30 }} className="ml-3">
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.some_amount)})
                          </span>

                          {/*<NumberFormat
                              className="form-control ml-3"
                              style={styles.inputLong}
                              thousandSeparator={true}
                              prefix={''}
                              placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.some_amount}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({some_amount: value}, () => this.calOutstanding())
                              }}
                              disabled={this.state.pay_type === 'ชำระครบถ้วน'}
                          />
                          <span style={{width: 50}} className="ml-1"> &nbsp;&nbsp;บาท&nbsp;&nbsp;</span>
                          <span className="ml-1" >( &nbsp; {ThaiBaht(this.state.some_amount)} &nbsp;)</span>*/}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">
                            ผู้ขายตกลงส่งมอบสำเนาคู่มือจดทะเบียนรถยนต์ในวันที่{" "}
                          </span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.handbook_copy_date_thai === null
                                ? ""
                                : this.state.handbook_copy_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startHandbookCopyDate}
                              onChange={this.handleHandbookCopyDate}
                              dateFormat="yyyy-MM-dd"
                              disable={this.state.pay_type === "ชำระครบถ้วน"}
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <span style={{ textDecoration: "underline" }}>
                          กรณีชำระเงินค่ารถยนต์ครบถ้วน
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">2.2) วันที่</span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.full_payment_date_thai === null
                                ? ""
                                : this.state.full_payment_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startDateFullPayment}
                              onChange={this.handleDateFullPayment}
                              dateFormat="yyyy-MM-dd"
                              disable={this.state.pay_type === "ชำระบางส่วน"}
                              type={"icon"}
                            />
                          </div>

                          <span className="ml-3">
                            ชำระเงินค่ารถยนต์ครบถ้วน จำนวนเงิน
                          </span>
                          <NumberFormat
                            className="form-control ml-3 mr-2"
                            style={styles.inputMedium}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.full_amount}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ full_amount: value });
                            }}
                            disabled={this.state.pay_type === "ชำระบางส่วน"}
                          />
                          <span style={{ width: 30 }} className="ml-3">
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.full_amount)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">โดยชำระเป็น </span>
                          <input
                            className="ml-4 mr-2"
                            type="radio"
                            name="pay_method"
                            id="pay_method1"
                            value="cash"
                            checked={this.state.pay_method === "cash"}
                            onChange={(e) => {
                              let val = e.target.value;
                              this.setState({
                                pay_method: val,
                              });
                            }}
                          />
                          <label id="pay_method1" className="mr-3">
                            เงินสด
                          </label>

                          <input
                            className="ml-3 mr-2"
                            type="radio"
                            name="pay_method"
                            id="pay_method2"
                            value="transfer"
                            checked={this.state.pay_method === "transfer"}
                            onChange={(e) => {
                              let val = e.target.value;
                              this.setState({
                                pay_method: val,
                              });
                            }}
                          />
                          <label id="pay_method2" className="mr-3">
                            โอนเงิน
                          </label>

                          <input
                            className="ml-3 mr-2"
                            type="radio"
                            name="pay_method"
                            id="pay_method3"
                            value="cheque"
                            checked={this.state.pay_method === "cheque"}
                            onChange={(e) => {
                              let val = e.target.value;
                              this.setState({
                                pay_method: val,
                              });
                            }}
                          />
                          <label id="pay_method3" className="mr-2">
                            เช็ค
                          </label>

                          <input
                            style={styles.inputLong}
                            className="form-control ml-1"
                            placeholder="ธนาคาร................สาขา................เลขที่เช็ค................"
                            disabled={this.state.pay_method !== "cheque"}
                            name="pay_method_detail"
                            value={this.state.pay_method_detail || ""}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">
                            ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถยนต์พร้อมเอกสารที่จำเป็นสำหรับการจดทะเบียนรถยนต์
                            ตามที่กรมการขนส่งทางบกกำหนดให้กับผู้ซื้อ ในวันที่{" "}
                          </span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.handbook_date_thai === null
                                ? ""
                                : this.state.handbook_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startHandbookDate}
                              onChange={this.handleHandbookDate}
                              dateFormat="yyyy-MM-dd"
                              disable={this.state.pay_type === "ชำระบางส่วน"}
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <hr />
                        <div className=" text-center mt-2">
                          <strong className="text-danger">
                            <h4>
                              --- เพิ่มข้อมูลเฉพาะกรณีออกสัญญาซื้อขายรถยนต์
                              แบบฟอร์มของ สคบ. ---
                            </h4>
                          </strong>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-3">
                          <strong className="text-title">
                            <span>ข้อ 3. กำหนดส่งมอบรถยนต์</span>
                          </strong>
                          <br />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">
                            ผู้ขายจะได้ทำการส่งมอบรถให้กับผู้ซื้อ
                            ในสภาพเรียบร้อยตรงตามวัตถุประสงค์ของผู้ซื้อทุกประการ
                            และให้ถือว่ากรรมสิทธิ์ในรถยนต์ได้โอนให้กับผู้ซื้อเรียบร้อยแล้ว
                            ในวันที่
                          </span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.car_date_delivery_thai === null
                                ? ""
                                : this.state.car_date_delivery_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startDateCarDelivery}
                              onChange={this.handleCarDeliveryDate}
                              dateFormat="yyyy-MM-dd"
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="ml-5">ณ สถานที่</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="location_delivery"
                            value={this.state.location_delivery}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span className="mr-3 ml-5">
                            ผู้ขายตกลงส่งมอบสมุดคู่มือทะเบียนรถพร้อมเอกสารที่จำเป็นสำหรับการจดทะเบียนรถยนต์
                            ตามที่กรมการขนส่งทางบกกำหนดให้กับผู้ซื้อ ในวันที่
                          </span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 160 }}
                            value={
                              this.state.send_car_date_thai === null
                                ? ""
                                : this.state.send_car_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startSendCarDate}
                              onChange={this.handleSendCarDate}
                              dateFormat="yyyy-MM-dd"
                              type={"icon"}
                            />
                          </div>
                          <span className="ml-3">
                            เมื่อมีการปฏิบัติตามสัญญากันครบถ้วนแล้ว
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 4. การบอกกล่าว ทวงถาม
                          </strong>
                          &nbsp;
                          <span>
                            {" "}
                            หรือส่งเอกสารใดๆ
                            อันพึงมีไปยังคู่สัญญาอีกฝ่ายหนึ่งตามภูมิลำเนาที่ปรากฏในสัญญานี้
                            ให้ถือว่าเป็นการส่งโดยชอบ
                            และคู่สัญญาอีกฝ่ายได้ทราบแล้วในวันที่คำบอกกล่าว
                            หรือเอกสารนั้นๆ พึงไปถึงตามปกติ
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 5. ผู้บริโภคมีสิทธิบอกเลิกสัญญา
                          </strong>
                          &nbsp;
                          <span>
                            {" "}
                            เมื่อผู้ประกอบธุรกิจกระทำการอย่างใดอย่างหนึ่ง
                            ดังต่อไปนี้
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            5.1)
                            มีการปรับเปลี่ยนราคารถยนต์สูงขึ้นจากที่ตกลงกันไว้
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            5.2)
                            ไม่ส่งมอบรถยนต์ให้กับผู้บริโภคภายในระยะเวลาที่กำหนด
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            5.3) ส่งมอบรถยนต์ที่มี ยี่ห้อ รุ่น ปี สี
                            หมายเลขเครื่องยนต์ หมายเลขตัวถัง
                            ขนาดกำลังเครื่องยนต์ หมายเลขทะเบียน
                            และอุปกรณ์ที่ติดมากับรถยนต์ (ถ้ามี)
                            รวมถึงระยะทางที่ได้ใช้แล้ว
                            โดยให้มีหน่วยเป็นกิโลเมตรหรือไมล์
                            ไม่ถูกต้องตามที่ตกลงกันไว้ในสัญญา
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            5.4)
                            ไม่สามารถดำเนินการจดทะเบียนรถยนต์ให้เป็นชื่อของผู้บริโภคตามสัญญา
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            ทั้งนี้ ผู้บริโภคที่ทำการบอกกล่าวเลิกสัญญาตามข้อ 5
                            จะต้องทำเป็นหนังสือบอกกล่าวขอเลิกสัญญาโดยอ้างเหตุผลข้อใดข้อหนึ่งหรือหลายข้อข้างต้น
                            พร้อมนำส่งหนังสือให้กับผู้ประกอบการธุรกิจ
                            โดยจะต้องมีหลักฐานที่ผู้ประกอบธุรกิจได้รับหนังสือนั้นแล้ว
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 6. เมื่อผู้บริโภคมีการบอกเลิกสัญญาตามข้อ 5 แล้ว
                          </strong>
                          &nbsp;
                          <span>
                            {" "}
                            ผู้ประกอบธุรกิจต้องคืนเงินหรือสิ่งใดที่ได้รับไว้ทั้งหมดแก่ผู้บริโภคภายในสิบห้าวันนับแต่วันที่ผู้ประกอบธุรกิจได้รับหนังสือบอกเลิกสัญญาจากผู้บริโภค
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 7. ในกรณีที่ไม่สามารถดำเนินการจดทะเบียนรถยนต์
                          </strong>
                          &nbsp;
                          <span>
                            ใช้แล้วเป็นชื่อผู้บริโภคหรือไม่สามารถส่งมอบรถยนต์ใช้แล้วให้ผู้บริโภค
                            หรือมีการบอกเลิกสัญญาขายรถยนต์ใช้แล้วโดยมิใช่ความผิดของผู้บริโภค
                            ผู้ประกอบธุรกิจจะคืนเงินที่ได้รับไว้แล้วทั้งหมด
                          </span>
                          <span>ให้กับผู้บริโภค</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 8. ผู้ประกอบธุกิจมีสิทธิบอกเลิกสัญญา
                            เมื่อปรากฏข้อเท็จจริงข้อใดข้อหนึ่งดังต่อไปนี้
                          </strong>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5" style={styles.text8}>
                            8.1) ผู้บริโภคไม่ชำระหนี้ตามกำหนด
                          </span>
                        </div>
                        <div className="form-inline">
                          <span className="ml-5" style={styles.text8}>
                            8.2)
                            ผู้บริโภคผิดสัญญาหรือผิดเงื่อนไขอันเป็นสาระสำคัญ
                            ได้แก่
                          </span>
                        </div>
                        <div className="form-inline">
                          <span style={{ ...styles.text8, paddingLeft: "5%" }}>
                            (1)
                            ผู้บริโภคไม่ดำเนินการติดต่อสถาบันการเงินเพื่อขอสินเชื่อภายใน
                          </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="request_loan"
                            value={this.state.request_loan}
                            onChange={this.handleOnChange}
                          />
                          <span style={{ ...styles.text8 }}>วัน</span>
                        </div>
                        <div className="form-inline">
                          <span style={{ ...styles.text8, paddingLeft: "5%" }}>
                            (2)
                            ผู้บริโภคไม่จัดส่งเอกสารให้กับผู้ประกอบธุรกิจหรือสถาบันการเงินที่ผู้ประกอบธุรกิจได้ประสารติดต่อภายในกำหนด
                          </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="send_doc"
                            value={this.state.send_doc}
                            onChange={this.handleOnChange}
                          />
                          <span style={{ ...styles.text8 }}>
                            วัน โดยไม่แจ้งเหตุผลให้ทราบ
                          </span>
                        </div>
                        <div className="form-inline">
                          <span style={{ ...styles.text8, paddingLeft: "5%" }}>
                            (3)
                            ผู้บริโภคเปลี่ยนใจไม่ต้องการรถยนต์คันที่จองหรือมัดจำไว้
                          </span>
                        </div>
                        <div className="form-inline">
                          <span style={{ ...styles.text8, paddingLeft: "5%" }}>
                            (4) อื่นๆ (ถ้ามี ระบุ)
                          </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="other_note"
                            value={this.state.other_note}
                            onChange={this.handleOnChange}
                          />
                        </div>
                        <div className="form-inline">
                          <span className="ml-5">
                            การบอกเลิกสัญญา
                            ผู้ประกอบธุรกิจจะต้องมีหนังสือบอกกล่าวให้ผู้บริโภคปฏิบัติตามสัญญาแล้วเป็นเวลาไม่น้อยกว่าสิบห้าวันนับแต่วันที่ผู้บริโภคได้รับหนังสือ
                            และผู้บริโภคละเลยเสียไม่ปฏิบัติตามหนังสือบอกกล่าวนั้น
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <strong className="text-title">
                            ข้อ 9. ผู้ประกอบธุรกิจไม่มีสิทธิ์ริบเงินทั้งหมด
                            หรือบางส่วน เว้นแต่ผู้บริโภคเป็นฝ่ายผิดสัญญา
                          </strong>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-5">
                          <span className="ml-5">
                            สัญญานี้ทำขึ้นเป็นสองฉบับ มีข้อความถูกต้องตรงกัน
                            ทั้งสองฝ่ายได้ทราบและเข้าใจข้อความโดยตลอดดีแล้วเห็นว่าตรงตามเจตนาของตน
                            จึงได้ลงลายมือชื่อ และประทับตรา (ถ้ามี)
                            ไว้เป็นสำคัญต่อหน้าพยาน และต่างยึดถือไว้ฝ่ายละฉบับ{" "}
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>
                          ลงชื่อ...............................................................................
                        </span>
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>
                          ลงชื่อ...............................................................................
                        </span>
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>
                          ลงชื่อ...............................................................................
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <input
                          type="text"
                          style={{ width: 250, borderRadius: "5px" }}
                          name="sign_buyer"
                          value={this.state.sign_buyer}
                          onChange={this.handleOnChange}
                        />
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <input
                          type="text"
                          style={{ width: 250, borderRadius: "5px" }}
                          name="sign_seller"
                          value={this.state.sign_seller}
                          onChange={this.handleOnChange}
                        />
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <input
                          type="text"
                          style={{ width: 250, borderRadius: "5px" }}
                          name="sign_evidence"
                          value={this.state.sign_evidence}
                          onChange={this.handleOnChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>ผู้ซื้อ</span>
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>ผู้ขาย</span>
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>(ผู้มีอำนาจออกหลักฐานการรับเงิน)</span>
                      </td>
                    </tr>

                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>
                          ลงชื่อ.....................................................................พยาน
                        </span>
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <span>
                          ลงชื่อ.....................................................................พยาน
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <input
                          type="text"
                          style={{ width: 250, borderRadius: "5px" }}
                          name="sign_witness1"
                          value={this.state.sign_witness1}
                          onChange={this.handleOnChange}
                        />
                      </td>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        <input
                          type="text"
                          style={{ width: 250, borderRadius: "5px" }}
                          name="sign_witness2"
                          value={this.state.sign_witness2}
                          onChange={this.handleOnChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 text-right mt-5">
                <div className="card-block">
                  {this.state.receipt_ocpd_id === null ? (
                    <button
                      type="button"
                      className="btn btn-success btn-md mr-2"
                      style={{ width: 120 }}
                      onClick={() => this.saveCarReceiptOcpd("add")}
                    >
                      <i className="icon-check" />
                      &nbsp;บันทึก
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-warning btn-md mr-2"
                      style={{ width: 120 }}
                      onClick={() => this.saveCarReceiptOcpd("edit")}
                    >
                      <i className="icon-pencil" />
                      &nbsp;แก้ไข
                    </button>
                  )}

                  {this.state.receipt_ocpd_id === null ? null : (
                    <button
                      type="button"
                      className="btn btn-primary btn-md mr-2"
                      style={{ width: 220 }}
                      onClick={() => this.printCarReceiptOcpd()}
                    >
                      <i className="icon-printer" /> พิมพ์หลักฐานการรับเงิน
                    </button>
                  )}

                  {this.state.receipt_ocpd_id === null ? null : (
                    <button
                      type="button"
                      className="btn btn-primary btn-md mr-2"
                      style={{ width: 240 }}
                      onClick={() => this.printContractOcpd()}
                    >
                      <i className="icon-printer" /> พิมพ์สัญญาซื้อขายรถ (สคบ.)
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  table: {
    width: "100%",
    maxWidth: "100%",
  },
  tdContentCenter: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  tdContentRight: {
    textAlign: "right",
    verticalAlign: "middle",
    justifyContent: "right",
  },
  tdContentLeft: {
    textAlign: "left",
    verticalAlign: "middle",
  },
  tableTh: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
  },
  tableTdLeft: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "top",
  },
  tableTdCenter: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "left",
    verticalAlign: "middle",
    paddingLeft: "70px",
  },
  tableTdRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
  },
  tablePd: {
    paddingLeft: "50px",
    paddingRight: "50px",
    lineHeight: "2.2",
  },
  amountsText: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  amountsTextNoBorder: {
    maxWidth: "100%",
    textAlign: "center",
    verticalAlign: "middle",
  },
  amountsRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
    fontWeight: "bold",
  },
  buttonHeight: {
    height: 32,
  },
  iconCalendar: {
    width: "50px",
  },
  inputData: {
    borderRadius: "5px",
    width: "450px",
  },
  inputDataNum: {
    borderRadius: "5px",
    width: "100px",
  },
  inputDataWriteAt: {
    borderRadius: "5px",
    width: "45%",
  },
  inputShort: {
    borderRadius: "5px",
    width: "120px",
  },
  inputMedium: {
    borderRadius: "5px",
    width: "190px",
  },
  inputLong: {
    borderRadius: "5px",
    width: "36%",
  },
  text8: {
    fontStyle: "italic",
    textDecoration: "underline",
    fontWeight: "bold",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CarReceiptOcpd);
